
<template>
<div>
    <b-form>
        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>

        <div class="box box-primary">
            <div class="box-header">
                <h3 class="box-title">{{$t('apartmentbookings.enter_customer_information')}}</h3>
            </div>
            <div class="box-body">
              <div style="border:0px solid red;background-color:#f7f7f7;display:flex;">

                <div style="border:0px solid blue;width:100%;">
                  <!--Left Contents-->
                  <div style="border:0px solid green;width:77%;" class="col-md-9">
                    <!--Booking Customer Information-->
                    <div style="border:2px solid #f29911;border-color:#f29911;background-color:white;margin:10px 10px 10px -5px;width:100%;" class="col-md-9">
                      <div class="row">
                        <div class="ribbon-22" style="width:140px;margin-bottom:20px;margin-top:20px;background-color:#f29911;color:white;font-weight:bold;">
                          <div style="padding:4px">{{$t('apartmentbookings.booking_customer_information')}}</div>
                        </div>
                        <!-- Booking code -->
                        <div class="row">
                          <div class="col-md-4" style="margin-left: 15px;">
                            <div class="form-group">
                              <label for="checkin">{{$t('apartmentbookings.booking_code')}}</label>
                              <input
                                disabled
                                v-model="apartment_bookings.booking_code"
                                type="text"
                                class="form-control"
                                :placeholder="$t('apartmentbookings.booking_code')"
                              >
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="checkin">{{$t('apartmentbookings.checkin_datetime')}}</label>
                            <date-picker :disabled="true" class="form-control" v-model="apartment_bookings.checkin_datetime" :config="options" ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="checkout">{{$t('apartmentbookings.checkout_datetime')}}</label>
                            <date-picker class="form-control" :value="apartment_bookings.checkout_datetime" v-model="apartment_bookings.checkout_datetime" :config="options" ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group warning">
                                <label for="number_of_days" class="control-label" :title="$t('apartmentbookings.number_of_days')">{{$t('apartmentbookings.number_of_days')}}</label>
                                <b-form-input :disabled="true" :value="get_number_of_days" type="number" :required="ischeck" class="form-control" id="number_of_days" :placeholder="$t('apartmentbookings.number_of_days')" />
                            </div>
                        </div>
                      </div>
                      <!--Booking Person Information-->
                      <div class="row">
                        <div class="col-md-4">
                              <div class="form-group required">
                                  <label for="first_name" class="control-label">{{$t('customer.firstname')}}</label>
                                  <input
                                    :disabled="disablecustomerform"
                                    v-model="apartment_bookings.booking_person_name"
                                    type="text"
                                    class="form-control"
                                    id="booking_person_name"
                                    :placeholder="$t('customer.firstname')"
                                    @input="validateFieldIsEmpty('booking_person_name', 'this.apartment_bookings.')"
                                  >
                                  <span v-if="this.field_required.booking_person_name != ''" class="help is-danger">
                                      <font color="red">{{ $t(field_required.booking_person_name) }}</font>
                                  </span>
                              </div>
                          </div>
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label for="email" class="control-label">{{$t('customer.email')}}</label>
                            <input
                                :disabled="disablecustomerform"
                                v-model="apartment_bookings.booking_person_email"
                                type="email"
                                class="form-control"
                                id="email"
                                placeholder="example@example.com"
                                @input="validateFieldIsEmpty('booking_person_email','this.apartment_bookings.')"
                            >

                            <span v-if="this.field_required.booking_person_email != ''" class="help is-danger">
                                <font color="red">{{ $t(field_required.booking_person_email) }}</font>
                            </span>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label for="phone" class="control-label">{{$t('customer.phone')}}</label>
                            <input
                              :disabled="disablecustomerform"
                              v-model="apartment_bookings.booking_person_phone"
                              type="text"
                              class="form-control"
                              id="phone"
                              :placeholder="$t('customer.phone')"
                              @input="validateFieldIsEmpty('booking_person_phone','this.apartment_bookings.')"
                            >
                            <span v-if="this.field_required.phone != ''" class="help is-danger">
                                <font color="red">{{ $t(field_required.booking_person_phone) }}</font>
                            </span>
                          </div>
                        </div>

                        
                      </div>

                      <!-- [loitt] - #1171 GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN -->
                      <div class="row">
                          <div class="col-md-12">
                              <div class="inside-section-header">
                                  <i data-v-2e17af2d="" class="fa fa-user"></i>
                                  <label>{{$t(`customer.info_invoice.title`)}}:</label>
                              </div>
                              <div class="row">
                                  <div class="col-md-3">
                                      <div class="form-group">
                                          <label for="cromcode">{{$t('customer.info_invoice.profile_company_name')}}</label>
                                          <input
                                              v-model="apartment_bookings.company_name"
                                              type="text"
                                              class="form-control"
                                              id="profile_company_name"
                                              :placeholder="$t('customer.info_invoice.profile_company_name')"
                                          >
                                      </div>
                                  </div>
                                  <div class="col-md-3">
                                      <div class="form-group">
                                          <label for="cromcode">{{$t('customer.info_invoice.profile_company_address')}}</label>
                                          <input
                                              v-model="apartment_bookings.company_address"
                                              type="text"
                                              class="form-control"
                                              id="profile_company_address"
                                              :placeholder="$t('customer.info_invoice.profile_company_address')"
                                          >
                                      </div>
                                  </div>
                                  <div class="col-md-3">
                                      <div class="form-group">
                                          <label for="cromcode">{{$t('customer.info_invoice.profile_company_tax_code')}}</label>
                                          <input
                                              v-model="apartment_bookings.company_tax_code"
                                              type="text"
                                              class="form-control"
                                              id="profile_company_tax_code"
                                              :placeholder="$t('customer.info_invoice.profile_company_tax_code')"
                                          >
                                      </div>
                                  </div>
                                  <div class="col-md-3">
                                      <div class="form-group">
                                          <label for="cromcode">{{$t('customer.info_invoice.profile_company_email')}}</label>
                                          <input
                                              v-model="apartment_bookings.company_email"
                                              type="email"
                                              class="form-control"
                                              id="profile_company_email"
                                              :placeholder="$t('customer.info_invoice.profile_company_email')"
                                          >
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="row">
                        <div class="col-md-4">
                              <div class="form-group required">
                                  <label for="first_name">{{$t('customer.company')}}</label>
                                  <b-form-select :disabled="disablecustomerform"
                                      :options="leaseback_company_list"
                                      v-model="apartment_bookings.booking_company"
                                      class="form-control"
                                      @change="onChangeCompany"
                                  />
                              </div>
                          </div>
                          <div class="col-md-4">
                            <button
                                type="button"
                                class="btn btn-labeled btn-primary"
                                @click="showModalAddCompany"
                                style="margin-right: 5px;background-color: #f29911;border-color: #f29911;margin-top:25px;"
                            >
                                <span class="btn-label">
                                <i class="fa fa-plus"></i>
                                </span>
                                {{$t('customer.company')}}
                            </button>
                          </div>
                      </div>
                      <div class="row">

                          <div class="col-md-12">
                              <div class="form-group">
                                  <label for="country">{{$t('common.note')}}</label>
                                  <textarea class="form-control" rows="5" v-model="apartment_bookings.other_booking_details" :placeholder="$t('common.note') + '...'"></textarea>
                              </div>
                          </div>
                      </div>
                      <!--Booking Person Information-->
                    </div>
                    <!--Booking Customer Information-->

                    <!--Booking Price Information-->
                    <div :disabled="this.booking_payment_id == 0 ? true : false" style="border:2px solid #f29911;border-color:#f29911;background-color:white;margin:10px 10px 10px -5px;width:100%;" class="col-md-9">
                      <div class="row">
                        <div class="ribbon-22" style="width:110px;margin-bottom:20px;margin-top:20px;background-color:#f29911;color:white;font-weight:bold;">
                          <div style="padding:4px">{{$t('apartmentbookings.booking_price_information.title')}}</div>
                        </div>
                      </div>
                      <div class="row">
                        <!-- Tinh tien -->
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label for="package_price_in_month">{{$t('service.package.payment_duration_factor')}}</label>
                            <b-form-select
                              :options="paymentDurationFactor"
                              v-model="apartment_bookings.payment_duration_factor"
                              @change="onChangePayment"
                              class="form-control"
                              :disabled="true"
                            />
                          </div>
                        </div>
                         <!-- Giá gói tháng -->
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label for="package_price_in_month">{{apartment_bookings.payment_duration_factor == 1 ? $t('apartmentbookings.booking_price_information.package_price_in_month') : apartment_bookings.payment_duration_factor == 2 ? $t('apartmentbookings.booking_price_information.package_price_in_week') : $t('apartmentbookings.booking_price_information.package_price_in_day')}}</label>
                            <input
                              :disabled="disablecustomerform"
                              v-model="apartment_bookings.booking_room_rate"
                              type="text"
                              class="form-control"
                              id="booking_room_rate"
                              readonly
                              :placeholder="$t('apartmentbookings.booking_price_information.package_price_in_month')"
                            >
                            <a v-on:click='onClickModify'>{{$t('common.modify')}}</a>
                            <a style="margin-left:15px" v-on:click='onClickReset'>{{$t('common.reset')}}</a>
                          </div>
                        </div>
                        <!-- Gía gói ngày -->
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label for="package_price_in_day">{{$t('apartmentbookings.booking_price_information.package_price_in_day')}}</label>
                            <input
                              :disabled="disablecustomerform"
                              v-model="apartment_bookings.package_price_in_day"
                              type="text"
                              class="form-control"
                              id="package_price_in_day"
                              readonly
                              :placeholder="$t('apartmentbookings.booking_price_information.package_price_in_day')"
                            >
                          </div>
                        </div>
                      </div>
                      <!-- // [loitt] - #838 -->
                      <div class="row">
                        <!-- Giarm giá -->
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label for="package_sale_off">{{$t('apartmentbookings.booking_price_information.package_sale_off')}}</label>
                            <input
                              :disabled="disablecustomerform"
                              :readonly="disable_all()"
                              v-model="apartment_bookings.sale_off"
                              type="text"
                              class="form-control"
                              id="package_sale_off"
                              @change="onBookingRoomRateChange"
                              v-on:keyup="onBookingRoomRateChange"
                              :placeholder="$t('apartmentbookings.booking_price_information.package_sale_off')"
                            >
                          </div>
                        </div>
                        <!-- Gía gói tháng guiarm -->
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label style="color: red" for="package_price_in_month">* {{apartment_bookings.payment_duration_factor == 1 ? $t('apartmentbookings.booking_price_information.package_price_in_month_adjust') : apartment_bookings.payment_duration_factor == 2 ? $t('apartmentbookings.booking_price_information.package_price_in_week_adjust') : $t('apartmentbookings.booking_price_information.package_price_in_day_adjust') }}</label>
                            <input
                              :disabled="disablecustomerform"
                              v-model="apartment_bookings.booking_room_rate_after_discount"
                              type="text"
                              class="form-control"
                              id="booking_room_rate"
                              readonly
                              :placeholder="$t('apartmentbookings.booking_price_information.package_price_in_month_adjust')"
                            >
                          </div>
                        </div>
                        <!-- Giá gói ngày giảm -->
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label style="color: red" for="package_price_in_day">* {{$t('apartmentbookings.booking_price_information.package_price_in_day_adjust')}}</label>
                            <input
                              :disabled="disablecustomerform"
                              v-model="apartment_bookings.package_price_in_day_after_discount"
                              type="text"
                              class="form-control"
                              id="package_price_in_day"
                              readonly
                              :placeholder="$t('apartmentbookings.booking_price_information.package_price_in_day_adjust')"
                            >
                          </div>
                        </div>
                        
                        </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label for="package_promotion">{{$t('apartmentbookings.booking_price_information.package_promotion')}}</label>
                            <input
                              :disabled="disablecustomerform"
                              v-model="apartment_bookings.discount"
                              type="text"
                              class="form-control"
                              id="discount"
                              :readonly="disable_all()"
                              @change="onBookingRoomRateChange"
                              v-on:keyup="onBookingRoomRateChange"
                              :placeholder="$t('apartmentbookings.booking_price_information.package_promotion')"
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group required">
                              <label for="phone">{{$t('apartmentbookings.status.payment_in_advance')}}</label>
                              <a 
                                v-on:click='onClickShowInvoiceGeneralInvoicePaymentInAdvance'
                                v-if="booking_id !== 0" 
                              >
                                <span class="btn-label" 
                                  :title="$t('apartmentbookings.booking_price_information.print_accept_invoice_general_invoice')">
                                  <i class="fa fa-plus"></i>
                                </span>
                              </a>
                              <input
                                :disabled="true"
                                @change="formatPaymentInAdvance"
                                v-on:keyup="formatPaymentInAdvance"
                                v-model="apartment_bookings.payment_in_advance"
                                type="text"
                                class="form-control"
                                id="payment_in_advance"
                                :readonly="disable_all()"
                                :placeholder="$t('apartmentbookings.status.payment_in_advance')"
                              >
                            </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label for="email">{{$t('apartmentbookings.status.deposit')}}
                            </label>
                            <a 
                              v-on:click='onClickShowInvoiceGeneralInvoiceDeposit'
                              v-if="booking_id !== 0"
                            >
                              <span class="btn-label" 
                                :title="$t('apartmentbookings.booking_price_information.print_accept_invoice_general_invoice')">
                                <i class="fa fa-plus"></i>
                              </span>
                            </a>
                            <input
                                :disabled="true"
                                v-model="apartment_bookings.deposit"
                                @change="formatDeposit"
                                v-on:keyup="formatDeposit"
                                type="text"
                                class="form-control"
                                id="deposit"
                                :readonly="disable_all()"
                                :placeholder="$t('apartmentbookings.status.deposit')"
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>{{$t('apartmentbookings.booking_price_information.deposit_request')}}: </label>
                            <!-- <input
                              :disabled="disablecustomerform"
                              type="text"
                              class="form-control"
                              id="deposit"
                              :readonly="disable_all()"
                            > -->
                            <input
                              v-model="apartment_bookings.payment_inadvance_request"
                              type="text"
                              class="form-control"
                              id="deposit_request"
                              @change="onChangeDepositRequestOrPaymentInadvanceRequest"
                              v-on:keyup="onChangeDepositRequestOrPaymentInadvanceRequest"
                              :placeholder="$t('apartmentbookings.booking_price_information.deposit_request')"
                            >
                            <!-- {{apartment_bookings.total_booking_room_rate_after_vat}} -->
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>{{$t('apartmentbookings.booking_price_information.payment_inadvance_request')}}: </label>
                            <!-- <input
                              :disabled="disablecustomerform"
                              type="text"
                              class="form-control"
                              id="deposit"
                              :readonly="disable_all()"
                            > -->
                            <input
                              v-model="apartment_bookings.deposit_request"
                              type="text"
                              class="form-control"
                              id="payment_inadvance_request"
                              @change="onChangeDepositRequestOrPaymentInadvanceRequest"
                              v-on:keyup="onChangeDepositRequestOrPaymentInadvanceRequest"
                              :placeholder="$t('apartmentbookings.booking_price_information.payment_inadvance_request')"
                            >

                            <!-- {{formatNumber(Math.round(formatInteger(apartment_bookings.total_booking_room_rate_after_vat) * 0.5))}} -->
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label>{{$t('apartmentbookings.deposit_deadline')}}</label>
                            <date-picker
                              @dp-change="onChangeDepositDate"
                              v-model="apartment_bookings.deposit_deadline"
                              :config="options"
                            ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4 ">
                          <div class="form-group required">
                            <label for="package_summary">{{$t('apartmentbookings.booking_price_information.summary')}}</label>
                            <input
                              :disabled="disablecustomerform"
                              v-model="apartment_bookings.package_summary"
                              type="text"
                              class="form-control"
                              id="package_summary"
                              readonly
                              :placeholder="$t('apartmentbookings.booking_price_information.summary')"
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label>{{$t('apartmentbookings.tax')}} ({{apartment_bookings.vat}}%)</label>
                            <input
                              disabled
                              v-model="apartment_bookings.booking_room_rate_after_vat"
                              type="text"
                              class="form-control"
                              :placeholder="'Thuế'"
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label style="color: blue;">* {{$t('apartmentbookings.summary_after_vat')}}</label>
                            <input
                              disabled
                              v-model="apartment_bookings.total_booking_room_rate_after_vat"
                              type="text"
                              class="form-control"
                              readonly
                              :placeholder="'Tổng Tiền Sau Thuê '"
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label style="color: blue;">* {{$t('apartmentbookings.booking_price_information.total_amount_request')}}</label>
                            <input
                              disabled
                              v-model="apartment_bookings.total_deposit"
                              type="text"
                              class="form-control"
                              readonly
                              :placeholder="'Tổng Tiền Giữ Chỗ'"
                            >
                          </div>
                        </div>
                      </div>
                      <!--Booking Price Information-->
                    </div>
                    <!--Booking Customer Information-->
                    <div style="border:2px solid #f29911;border-color:#f29911;background-color:white;margin:10px 10px 10px -5px;width:100%;" class="col-md-9">
                      <div class="row">
                        <div class="col-md-3" style="margin: 0;padding:0;">
                          <div class="ribbon-22" style="width:160px;margin-bottom:20px;margin-top:20px;background-color:#f29911;color:white;font-weight:bold;">
                          <div style="padding:5px">{{$t('apartmentbookings.booking_service_information.title')}}
                            <a style="padding:5px" v-on:click='onClickShowInvoiceGeneralInvoicePaymentInService'>
                              <span class="btn-label">
                                <i class="fa fa-plus"></i>
                              </span>
                            </a>
                          </div>
                        </div>
                        </div>
                        <div class="col-md-10">

                           <div class="form-group" style="float:right;margin-top: 15px; ;margin-left: 10px;">
                            <label
                              style="display:inline-block;text-vertical: center"
                              for="serviceFree"
                              class="control-label"
                            >{{$t('apartmentbookings.booking_service_information.ew_included')}}</label>
                            <div style="display:inline-block;margin-left: 5px;">
                              <input
                                style="width: 15px; height: 15px;"
                                class="control-label"
                                type="checkbox"
                                v-model="apartment_bookings.ew_included"
                              >
                            </div>
                          </div>

                          <div class="form-group" style="float:right;margin-top: 15px">
                            <label
                              style="display:inline-block;text-vertical: center"
                              for="serviceFree"
                              class="control-label"
                            >{{$t('apartmentbookings.booking_service_information.has_breakfast')}}</label>
                            <div style="display:inline-block;margin-left: 5px;">
                              <input
                                style="width: 15px; height: 15px;"
                                class="control-label"
                                type="checkbox"
                                v-model="apartment_bookings.has_breakfast"
                              >
                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group required">
                            <label>{{$t('apartmentbookings.other_detail')}}</label>
                            <textarea
                              class="form-control"
                              placeholder="Ghi Chú"
                              rows="5"
                              v-model="apartment_bookings.pkg_other_detail"
                              :readonly="disable_all()"
                            >
                            </textarea>
                          </div>

                          <!-- 957: [loitt] - field Điện xxxx-->
                          <div class="form-group">
                            <label>{{$t('apartmentbookings.service_start_e')}}</label>
                            <input
                              type="text"
                              class="form-control"
                              :placeholder="$t('apartmentbookings.service_start_e')"
                              v-model="apartment_bookings.start_e"
                              @change="onChangeElectronic"
                              v-on:keyup="onChangeElectronic"
                              :readonly="disable_all()"
                            >
                          </div>
                          <!-- 957: [loitt] - field Nước -->
                          <div class="form-group">
                            <label>{{$t('apartmentbookings.service_start_w')}}</label>
                            <input
                              type="text"
                              class="form-control"
                              :placeholder="$t('apartmentbookings.service_start_w')"
                              v-model="apartment_bookings.start_w"
                              @change="onChangeWater"
                              v-on:keyup="onChangeWater"
                              :readonly="disable_all()"
                            >
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group required">
                            <label>{{$t('apartmentbookings.total_fee_service')}}</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Chi Phí Khác Trước Thuế"
                              v-model="apartment_bookings.pkg_other_fee"
                              @change="onBookingOtherFeeChange"
                              v-on:keyup="onBookingOtherFeeChange"
                              :readonly="disable_all()"
                            >
                          </div>
                          <div class="form-group required">
                            <label>{{$t('apartmentbookings.tax')}} (%)</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Thuế"
                              v-model="apartment_bookings.pkg_other_vat"
                              @change="onBookingOtherFeeChange"
                              v-on:keyup="onBookingOtherFeeChange"
                              :readonly="disable_all()"
                            >
                          </div>
                          <div class="form-group required">
                            <label>{{$t('apartmentbookings.tax')}} (VND)</label>
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Tiền Thuế"
                              v-model="apartment_bookings.pkg_other_fee_vat"
                              @change="onBookingOtherFeeChange"
                              v-on:keyup="onBookingOtherFeeChange"
                            >
                          </div>
                          <div class="form-group required">
                            <label>{{$t('apartmentbookings.summary_after_vat')}}</label>
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Tổng Chi Phí Sau Thuế"
                              v-model="apartment_bookings.total_pkg_other_fee_after_vat"
                              @change="onBookingOtherFeeChange"
                              v-on:keyup="onBookingOtherFeeChange"
                            >
                          </div>
                        </div>
                      </div>
                      <!--Booking Price Information-->
                    </div>



                    <!--loitt - BEGIN lease Customer Information-->
                    <div style="border:2px solid #f29911;border-color:#f29911;background-color:white;margin:10px 10px 10px -5px;width:100%;" class="col-md-9">
                      <div class="row">
                        <div class="ribbon-22" style="width:162px;margin-bottom:20px;margin-top:20px;background-color:#f29911;color:white;font-weight:bold;">
                          <div style="padding:4px">{{$t('apartmentbookings.apartment_leaseback_clients.title')}}</div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="cmnd_passport" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport')}}</label>
                            <input
                              :disabled="disablecustomerform"
                              v-model="apartment_leaseback_clients.id_passsport"
                              type="text"
                              class="form-control"
                              id="cmnd_passport"
                              :placeholder="$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport')"
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                              <label for="cmnd_passport_date" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport_date')}}</label>
                              <date-picker :placeholder="$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport_date')" class="form-control" v-model="apartment_leaseback_clients.id_passsport_issued_date" :config="options" id="cmnd_passport_date"></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <button
                              type="button"
                              class="btn btn-labeled btn-primary"
                              @click="clickEventOpenModalLeasebackClients"
                              style="margin-right: 5px;background-color: #f29911;border-color: #f29911;margin-top:25px;"
                            >
                              <span class="btn-label">
                              <i class="fa fa-users"></i>
                              </span>
                              {{$t('apartmentbookings.apartment_leaseback_clients.client')}}
                            </button>
                          </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group required">
                                <label for="full_name" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.fullname')}}</label>
                                <input
                                  :disabled="disablecustomerform"
                                  v-model="apartment_leaseback_clients.full_name"
                                  type="text"
                                  class="form-control"
                                  id="full_name"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.fullname')"

                                >
                            </div>
                        </div>

                        <div class="col-md-4">
                          <div class="form-group">
                              <label for="dob" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.dob')}}</label>
                              <date-picker :placeholder="$t('apartmentbookings.apartment_leaseback_clients.dob')" class="form-control" v-model="apartment_leaseback_clients.dob" :config="options" id="dob"></date-picker>
                          </div>
                        </div>


                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="address" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.address')}}</label>
                                <input
                                  :disabled="disablecustomerform"
                                  v-model="apartment_leaseback_clients.address"
                                  type="text"
                                  class="form-control"
                                  id="address"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.address')"

                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="email" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.email')}}</label>
                                <input
                                  :disabled="disablecustomerform"
                                  v-model="apartment_leaseback_clients.email"
                                  type="email"
                                  class="form-control"
                                  id="email"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.email')"

                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="phone" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.phone')}}</label>
                                <input
                                  :disabled="disablecustomerform"
                                  v-model="apartment_leaseback_clients.phone"
                                  type="text"
                                  class="form-control"
                                  id="phone"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.phone')"

                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="gender" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.gender')}}</label>
                                <select :disabled="disablecustomerform" v-model="apartment_leaseback_clients.gender" class="form-control">
                                    <option
                                        v-for="gender in gender_list"
                                        v-bind:value="gender.id"
                                        :key="gender.id"
                                    >{{ $t(gender.text) }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="country_code">{{$t('apartmentbookings.apartment_leaseback_clients.country')}}</label>
                                <b-form-select :disabled="disablecustomerform"
                                    :options="country_list"
                                    v-model="apartment_leaseback_clients.country_code"
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Ngày Giờ Check-in</label>
                                <date-picker :placeholder="$t('apartment.reservations.date_checkin')" class="form-control" v-model="apartment_leaseback_clients.checkin_datetime" :config="dateTimeOptions" id="visa_expired_date"></date-picker>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Ngày Giờ Check-out</label>
                                <date-picker :placeholder="$t('apartment.reservations.date_checkout')" class="form-control" v-model="apartment_leaseback_clients.checkout_datetime" :config="dateTimeOptions"></date-picker>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.flight')}}</label>
                                <input
                                  v-model="apartment_leaseback_clients.flight"
                                  type="text"
                                  class="form-control"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.flight')"
                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.visa_number')}}</label>
                                <input
                                  v-model="apartment_leaseback_clients.visa_number"
                                  type="text"
                                  class="form-control"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.visa_number')"
                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.visa_expired_date')}}</label>
                                <date-picker :placeholder="$t('apartmentbookings.apartment_leaseback_clients.visa_expired_date')" class="form-control" v-model="apartment_leaseback_clients.visa_expired_date" :config="options" id="visa_expired_date"></date-picker>
                            </div>
                        </div>
                        <div class="col-md-4" v-if="false">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_start')}}</label>
                                <date-picker :placeholder="$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_start')" class="form-control" v-model="apartment_leaseback_clients.vn_tmp_stay_start" :config="options"></date-picker>
                            </div>
                        </div>
                        <div class="col-md-4" v-if="false">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_end')}}</label>
                                <date-picker :placeholder="$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_end')" class="form-control" v-model="apartment_leaseback_clients.vn_tmp_stay_end" :config="options"></date-picker>
                            </div>
                        </div>
                        <div class="col-md-4" v-if="false">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.represent')}}</label>
                                <input
                                  v-model="apartment_leaseback_clients.represent"
                                  type="text"
                                  class="form-control"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.represent')"
                                >
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="other_details" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.other_details')}}</label>
                                <textarea
                                  :disabled="disablecustomerform"
                                  v-model="apartment_leaseback_clients.other_details"
                                  class="form-control"
                                  id="other_details"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.other_details')"
                                  rows="5"
                                >
                                </textarea>
                            </div>
                        </div>
                      </div>

                      <div class="row">
                        <button
                          type="button"
                          class="btn btn-labeled btn-info pull-right"
                          style="margin-right: 5px;"
                          @click="onResetApartmentLeasebackClients"
                        >
                          <span class="btn-label">
                            <i class="glyphicon glyphicon-repeat"></i>
                          </span>
                          {{$t('apartmentbookings.apartment_leaseback_clients.reset')}}
                        </button>
                        <button
                          type="button"
                          class="btn btn-labeled btn-info pull-right"
                          style="margin-right: 5px;"
                          @click="onSaveApartmentLeasebackClients"
                        >
                          <span class="btn-label">
                            <i class="glyphicon glyphicon-edit"></i>
                          </span>
                          {{$t('apartmentbookings.apartment_leaseback_clients.save')}}
                        </button>
                        <button
                          type="button"
                          class="btn btn-labeled btn-info pull-right"
                          style="margin-right: 5px;"
                          @click="onPrintPdfApartmentLeasebackClients"
                        >
                          <span class="btn-label">
                            <i class="glyphicon glyphicon-edit"></i>
                          </span>
                          {{$t('apartmentbookings.apartment_leaseback_clients.print_pdf')}}
                        </button>
                      </div>

                    <hr/>
                    <h4 style="text-align:center; color: blue;">{{$t('apartmentbookings.apartment_leaseback_clients.registered_clients')}}</h4>
                    <!--loitt - BEGIN Load info lease customer information-->
                    <div>
                      <table id="dtHorizontal" class="table-bordered table-striped mb-0">
                        <thead>
                          <th>STT</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.main_contact')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.fullname')}}</th>
                          <th>{{$t('apartmentbookings.checkin_datetime')}}</th>
                          <th>{{$t('apartmentbookings.checkout_datetime')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.flight')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport_date')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.address')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.email')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.phone')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.dob')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.gender')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.country')}}</th>
                          <th v-if="false">{{$t('apartmentbookings.apartment_leaseback_clients.represent')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.visa_number')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.visa_expired_date')}}</th>
                          <th v-if="false">{{$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_start')}}</th>
                          <th v-if="false">{{$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_end')}}</th>
                          <th>{{$t('common.action')}}</th>
                        </thead>
                        <tbody>
                          <tr v-for="(items, index) in list_apartment_lease_back_clients_selected" :key="index">
                            <td class="col-sm-1 col-md-1 col-lg-1">
                              {{index + 1}}
                            </td>
                            <td style="text-align: center;vertical-align: middle;" class="col-sm-1 col-md-1 col-lg-1">
                              <div class="btn-group">
                                <input :checked="items.selected" type="radio" name="mainContact" class="btn btn-sm btn-info" @click="selectMainContact(items)">
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div @click="onEditApartmentLeaseBackClient(items)" style="cursor: pointer;" v-if="items!==selectedItemLeaseBackClient">
                                {{items.full_name}}
                              </div>
                              <div v-else>
                                <input type="text" v-model="items.full_name" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTimeWithHour(items.checkin_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') != 'Invalid date' ? formatDateTimeWithHour(items.checkin_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') : null}}
                              </div>
                              <div v-else>
                                <input type="text" v-model="items.full_name" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTimeWithHour(items.checkout_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') != 'Invalid date' ? formatDateTimeWithHour(items.checkout_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') : null}}
                              </div>
                              <div v-else>
                                <input type="text" v-model="items.full_name" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Flight -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.flight}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.flight" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.id_passsport}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.id_passsport" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Passport date -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTime(items.id_passsport_issued_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') != 'Invalid date' ? formatDateTime(items.id_passsport_issued_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.id_passsport_issued_date" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Address -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.address}}
                              </div>
                              <div v-else>
                                <input type="text" v-model="items.address" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.email}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.email" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.phone}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.phone" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTime(items.dob, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') != 'Invalid date' ? formatDateTime(items.dob, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.dob" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Gender -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.gender == 1 ? $t('customer.gender_type[0]') : (items.gender == 2 ? $t('customer.gender_type[1]') : $t('customer.gender_type[2]'))}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.gender" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Country -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{getCountryName(items.country)}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.country" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Represent -->
                            <td class="col-sm-2 col-md-2 col-lg-2" v-if="false">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.represent}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.represent" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Visa Number -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.visa_number}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.visa_number" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Visa Expired Date -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTime(items.visa_expired_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') != 'Invalid date' ? formatDateTime(items.visa_expired_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.visa_expired_date" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Vn Tmp Stay Start -->
                            <td class="col-sm-2 col-md-2 col-lg-2" v-if="false">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTime(items.vn_tmp_stay_start, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') != 'Invalid date' ? formatDateTime(items.vn_tmp_stay_start, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.vn_tmp_stay_start" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Vn Tmp Stay End -->
                            <td class="col-sm-2 col-md-2 col-lg-2" v-if="false">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTime(items.vn_tmp_stay_end, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') != 'Invalid date' ? formatDateTime(items.vn_tmp_stay_end, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.vn_tmp_stay_end" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-1 col-md-1 col-lg-1">
                              <div class="btn-group">
                                <button type="button" class="btn btn-sm btn-info" @click="onEditApartmentLeaseBackClient(items)">
                                  <i class="fa fa-edit"></i>
                                </button>
                              </div>
                              <div class="btn-group">
                                <button type="button" class="btn btn-sm btn-warning"  @click="onDeleteApartmentLeaseBackClient(items)">
                                  <i class="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <span v-if="list_apartment_lease_back_clients_selected.length === 0" style="color:red;"><i>{{$t('apartmentbookings.apartment_leaseback_clients.no_registered_clients')}}</i></span>
                    </div>
                    <!--loitt - END Load info lease customer information-->

                    </div>

                    <!--loitt - END lease Customer Information-->

                  </div>
                  <!--Left Contents-->
                  <!--Right Contents-->
                  <div class="col-md-3" style="width: 23% !important;top:0">
                      <div class="row right-element-container">
                          <!-- <div style="border:0px solid red;position: absolute;left: 0px;width: 100%;height:auto;"> -->
                              <!--<div style="border:1px solid #cecece;width:130px;margin-top:20px;background-color:#cecece;color:black;font-weight:bold;">
                              {{$t('apartmentbookings.apartment_information')}}
                              </div>-->
                              <div class="ribbon-2" style="border:1px solid #cecece;width:150px;margin-top:20px;color:black;font-weight:bold;">
                                <div style="padding:3px;">{{$t('apartmentbookings.apartment_information')}}
                                  <a 
                                    v-on:click='onClickShowEditApartmentInfo'
                                    v-if="booking_id !== 0" 
                                  >
                                    <span
                                      :title="$t('apartmentbookings.booking_price_information.edit_apartment_information')">
                                      <i class="fa fa-edit"></i>
                                    </span>
                                  </a>
                                </div>
                              </div>
                              <div style="border:0px solid red;margin-top:15px;">
                              <table id="apartmentInformation" style="margin-left:12px;border-collapse:separate;border-spacing: 0 1em;">
                                  <!-- Apartment code -->
                                  <tr >
                                  <td style="width: 10px !important;">
                                  <span class="glyphicon glyphicon-sound-5-1 fa-lg" style="color:gray;"></span>
                                  </td>
                                  <td>&nbsp;&nbsp;&nbsp;</td>
                                  <td>
                                      {{$t('apartment.apartment_code')}}: <b>{{apartment.apartment_code}}</b>
                                  </td>
                                  </tr>
                                  <!-- Apartment size -->
                                  <tr>
                                  <td style="width: 10px !important;">
                                  <span class="glyphicon glyphicon-home fa-lg" style="color:gray;"></span>
                                  </td>
                                  <td>&nbsp;&nbsp;&nbsp;</td>
                                  <td>
                                      {{$t('apartment.size')}}: <b>{{apartment.size}}m<sup>2</sup></b>
                                  </td>
                                  </tr>
                                  <!-- Bedroom in apartment -->
                                  <tr>
                                  <td style="width: 10px !important;">
                                  <span class="glyphicon glyphicon-bed fa-lg" style="color:gray;"></span>
                                  </td>
                                  <td>&nbsp;&nbsp;&nbsp;</td>
                                  <td>
                                      {{$t('apartment.bedroom_count')}}: <b>{{apartment.bedroom_count}}</b>
                                  </td>
                                  </tr>
                                  <!-- <tr>
                                  <td style="width: 10px !important;">
                                  <span class="fa fa-s15 fa-lg" style="color:gray;"></span>
                                  </td>
                                  <td>&nbsp;&nbsp;&nbsp;</td>
                                  <td>
                                      {{$t('apartment.bathroom_count')}}: <b>{{apartment.bathroom_count}}</b>
                                  </td>
                                  </tr> -->
                                  <!-- <tr>
                                  <td style="width: 10px !important;">
                                  <span class="fa fa-bell fa-lg" style="color:gray;"></span>
                                  </td>
                                  <td>&nbsp;&nbsp;&nbsp;</td>
                                  <td>
                                      {{$t('apartment.room_count')}}: <b>{{apartment.room_count}}</b>
                                  </td>
                                  </tr> -->
                                  <!-- Điện -->
                                  <!-- <tr>
                                  <td style="width: 10px !important;">
                                  <span class="fa fa-bolt fa-lg" style="color:gray;"></span>
                                  </td>
                                  <td>&nbsp;&nbsp;&nbsp;</td>
                                  <td>
                                      {{$t('apartment.electric_value')}}: <b>{{apartment.electric_value}} kWh</b>
                                  </td>
                                  </tr> -->
                                  <!-- Nước -->
                                  <!-- <tr>
                                  <td style="width: 10px !important;">
                                  <span class="fa fa-tint fa-lg" style="color:gray;"></span>
                                  </td>
                                  <td>&nbsp;&nbsp;&nbsp;</td>
                                  <td>
                                      {{$t('apartment.water_value')}}: <b>{{apartment.water_value}} m³</b>
                                  </td>
                                  </tr> -->
                              </table>
                              </div>
                          <!-- </div> -->
                      </div>
                      <div v-if="false" class="row right-element-container">
                          <div class="ribbon-21" style="width:90px;margin-bottom:20px;margin-top:20px;background-color:#488BF8;color:white;font-weight:bold;">
                            <div style="padding:4px;">{{$t('apartmentbookings.package')}}</div>
                          </div>
                          <div class="col-md-12">
                            <LeaseBackBookingPackageView
                                @package-select="onPackageSelect"
                                @package-onemonth-elements="onPackageOneMonthObject"
                                @package-current-elements="onPackageCurrent"
                                :id="apartment_id"
                                :pkg="apartment_bookings.pkg"
                            />
                          </div>
                      </div>
                      <div class="row right-element-container">
                          <div class="ribbon-21" style="width:90px;margin-bottom:20px;margin-top:20px;background-color:#488BF8;color:white;font-weight:bold;">
                            <div style="padding:4px;">{{$t('apartmentbookings.package')}}</div>
                          </div>
                          <div class="col-md-12">
                            <!-- Select option package -->
                            <leaseback-select-option-package
                              @package-onemonth-elements="onPackageOneMonthObject"
                              @package-current-elements="onPackageCurrent"
                              @clickOnItem="onChangeSelect"
                              :packageId="apartment_bookings.pkg"
                              :apartmentId="apartment_id"
                            />
                          </div>
                      </div>
                  </div>
                  <!--Right Contents-->
                </div>
              </div>
            </div>
            <!-- /.box-body -->
            <div class="box-footer">
                <div class="col-md-9" style="border:0px solid red;">
                <button
                    type="button"
                    class="btn btn-labeled btn-danger"
                    @click="CancelCustomerList"
                    style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
                >
                    <span class="btn-label">
                    <i class="fa fa-mail-reply"></i>
                    </span>
                    {{$t('common.back')}}
                </button>
                <button
                    type="button"
                    class="btn btn-labeled btn-danger"
                    @click="sendEmailConfirmedBooking"
                    style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
                    v-if="booking_id !== 0"
                >
                    <span class="btn-label">
                    <i class="fa fa-print"></i>
                    </span>
                    In Thư Xác Nhận Đặt Phòng
                </button>
                <button
                    v-if="booking_id === 0 && !is_view_only || isCopyBooking"
                    type="button"
                    class="btn btn-labeled btn-success pull-right"
                    @click="saveBooking(booking_status = BookingStatusEnum.CONFIRMED)"
                    style="margin-right: 5px;"
                >
                    <span class="btn-label">
                    <i class="glyphicon glyphicon-ok"></i>
                    </span>
                    {{$t('common.confirm_booking')}}
                </button>
                <button
                    v-if="apartment_bookings.booking_status !== BookingStatusEnum.ONBOARD && apartment_bookings.booking_status != CHECKOUT && !is_view_only || isCopyBooking"
                    type="button"
                    class="btn btn-labeled btn-success pull-right"
                    @click="saveBooking(booking_status = BookingStatusEnum.ONBOARD)"
                    style="margin-right: 5px;"
                >
                    <span class="btn-label">
                    <i class="glyphicon glyphicon-copy"></i>
                    </span>
                    {{$t('common.checkin')}}
                </button>
                <div class="btn-group pull-right" style="margin-right: 5px;" v-if="booking_id !== 0 && apartment_bookings.booking_status != BookingStatusEnum.CHECKOUT && !is_view_only && !isCopyBooking">
                  <button type="button" class="btn btn-info" @click="saveBooking()">
                    <i class="glyphicon glyphicon-edit"></i>
                    {{$t('common.edit_booking')}}
                  </button>
                  <button v-if="apartment_bookings.booking_status != BookingStatusEnum.ONBOARD" type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="caret"></span>
                    <span class="sr-only">Toggle Dropdown</span>
                  </button>
                  <ul class="dropdown-menu" role="menu">
                    <li><a @click="saveBooking()">{{$t('common.edit_booking')}}</a></li>
                    <li><a @click="saveBooking(booking_status = BookingStatusEnum.DEPOSIT)">{{$t('common.deposit_booking')}}</a></li>
                  </ul>
                </div>
                <button
                    v-if="booking_id !== 0 && apartment_bookings.booking_status != BookingStatusEnum.ONBOARD && apartment_bookings.booking_status != BookingStatusEnum.CHECKOUT && !is_view_only && !isCopyBooking"
                    type="button"
                    class="btn btn-labeled btn-warning pull-right"
                    @click="saveBooking(booking_status = BookingStatusEnum.CANCELLED)"
                    style="margin-right: 5px;"
                >
                    <span class="btn-label">
                    <i class="glyphicon glyphicon-remove"></i>
                    </span>
                    {{$t('common.cancel_booking')}}
                </button>
                </div>
            </div>
            <b-button ref="formsubmitbutton" type="submit" variant="primary" style="display: none;">{{$t('common.submit')}}</b-button>
        </div>
    </b-form>
    <lte-modal-partment-leaseback-company
      ref="modalApartmentLeaseBackCompany"
      @reload_leaseback_company="reloadLeaseBackCompany"
    ></lte-modal-partment-leaseback-company>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>

    <!-- Modal Load Update package Information -->
    <div class="modal fade" id="modal-main-package-price" :ref="`modal-main-package-price`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="col-md-12">
                <div class="form-group required">
                  <label for="phone">{{$t('apartmentbookings.booking_price_information.package_price_in_month')}}</label>
                  <input
                    :disabled="disablecustomerform"
                    v-model="apartment_bookings.modal_booking_room_rate"
                    class="form-control"
                    id="booking_room_rate"
                    @change="onBookingRoomRateChangeModal"
                    v-on:keyup="onBookingRoomRateChangeModal"
                    :placeholder="$t('apartmentbookings.booking_price_information.package_price_in_month')"
                  >
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group required">
                  <label for="phone">{{$t('apartmentbookings.booking_price_information.package_price_in_day')}}</label>
                  <input
                    :disabled="disablecustomerform"
                    v-model="apartment_bookings.modal_package_price_in_day"
                    type="text"
                    class="form-control"
                    id="booking_room_rate"
                    readonly
                    :placeholder="$t('apartmentbookings.booking_price_information.package_price_in_day')"
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              @click="onCancelBookingRoomRate"
            >{{$t('common.back')}}</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onSaveBookingRoomRate"
            >{{$t('common.save')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!--Modal Load Main Person Information -->


    <!-- Delete Confirm Modal Component -->
    <div class="modal fade" id="modal-apartment-leaseback-client-delete">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">{{$t('apartmentbookings.apartment_leaseback_clients.modal_apartment_leaseback_client.deletetitle')}}</h4>
          </div>
          <div class="modal-body">
            {{$t('apartmentbookings.apartment_leaseback_clients.modal_apartment_leaseback_client.deletemsg')}}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" style="background-color: #f29911;border-color: #f29911;color:#fff">{{$t('common.back')}}</button>
            <button type="button" class="btn btn-primary btn-green" @click="onConfirmDelete">{{$t('common.confirm')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <!-- Modal Cancel Apartment Booking -->
    <div class="modal fade" id="modal-cancel-apartment-booking">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Xác Nhận Hủy Đặt Phòng</h4>
          </div>
          <div class="modal-body">
            <p>- {{$t('apartment.customer')}}: {{apartment_bookings.booking_person_name}}</p>
            <p>- {{$t('apartment.apartment_code')}}: {{apartment.apartment_code}}</p>
            <p>- {{$t('apartmentbookings.booking_code')}}: {{apartment_bookings.booking_code}}</p>
            <p v-if="apartment_bookings.deposit != 0">- Tiền cọc: {{apartment_bookings.deposit}}</p>
            <p>- {{$t('apartmentbookings.reason')}}</p>
            <textarea class="form-control" rows="4" v-model="apartment_bookings.other_booking_details" :placeholder="$t('apartmentbookings.reason') + '...'"></textarea>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" style="background-color: #f29911;border-color: #f29911;color:#fff">{{$t('common.back')}}</button>
            <button type="button" class="btn btn-primary btn-green" @click="confirmCancelApartmentBooking">{{$t('common.confirm')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <!-- Modal Confirm Apartment Booking -->
        <div class="modal fade" id="modal-confirm-apartment-booking">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Xác Nhận Nhận Phòng</h4>
              </div>
              <div class="modal-body">
                <p>Bạn có muốn nhận phòng căn {{apartment.apartment_code}}</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default pull-left" data-dismiss="modal" style="background-color: #f29911;border-color: #f29911;color:#fff">{{$t('common.back')}}</button>
                <button type="button" class="btn btn-primary btn-green" @click="onConfirmApartmentBooking">{{$t('common.confirm')}}</button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
    <!-- /.modal -->
    <select-lease-back-clients-modal id="modal-select-client" :userId="1" @doSelectClient="doSelectClient" />

    <lte-modal-invoice-general-invoice-detail
          ref="modalInvoiceGeneralInvoiceDetail"
          @callbackInvoiceGeneralInvoiceSuccess="onInvoiceGeneralInvoiceSuccess"
        ></lte-modal-invoice-general-invoice-detail>

    <lte-modal-update-apartment-info
          ref="modalUpdateApartmentInfo"
          @callbackUpdateApartmentInfoSuccess="onUpdateApartmentInfoSuccess"
        ></lte-modal-update-apartment-info>

      
</div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from "moment";
import Loading from "vue-loading-overlay";
import {
    mapGetters,
    mapActions
} from "vuex";
import constantsData from '@/lib/constantsData';
import utils from '@/lib/utils';
import i18n from '../../lang';
import LeaseBackBookingPackageView from './LeaseBackBookingPackageView.vue'
import LeaseBackSelectOptionPackage from '@/components/SelectOptionPackage'
import LTEModalApartmentLeasebackCompany from "@/components/LTEModalApartmentLeasebackCompany";
import SelectLeaseBackClientsModal from "@/components/SelectLeaseBackClientsModal.vue";
import LTEModalInvoiceGeneralInvoiceDetail from "@/components/LTEModalInvoiceGeneralInvoiceDetail";
import LTEModalUpdateApartmentInfo from "@/components/LTEModalUpdateApartmentInfo";
import BookingStatusEnum from "@/enum/bookingStatusEnum";

export default {
    name: "LeaseBackApartmentBooking",
    data() {
        return {
            booking_id: 0,
            apartment_id: 0,
            booking_payment_id: 0,
            disablecustomerform: false,
            ischeck: false,
            timeCurrent: "2019-01-16T06:00:00Z",
            resident_type:"owner",
            customers: [],
            itemCustomer: {
              data_list: [],
              itemType: 0,
              showLabel: false,
              modifyFromPosition: "margin-top:-300px",
              cssClassSm1: "col-md-3",
              cssClassSm2: "col-sm-6",
              showAddNew: false
            },
            apartment: {
                id: 0,
                apartment_code: "",
                size: "",
                bathroom_count: 0,
                bedroom_count: 0,
                room_count: 0,
                electric_value: 0,
                water_value: 0
            },
            main_person: {
              id: 0,
              resident: {
                id: null,
                first_name: "",
                last_name: "",
                email: "",
                username: "",
                phone: "",
                country_name: "",
                dob: null,
                gender: 0
              },
              resident_movein: null,
              resident_moveout: null,
              start_efigure: 0,
              start_wfigure: 0,
              resident_status: null,
              available_customers: []
            },
            options: {
                format: "DD/MM/YYYY",
                useCurrent: false,
                //maxDate: moment().subtract(2, "days"),
            },
            dateTimeOptions: {
                format: "DD/MM/YYYY HH:mm",
                useCurrent: false,
                //maxDate: moment().subtract(2, "days"),
            },
            country_list: [],
            leaseback_company_list:[{value: null, text: "---"}],
            oldPassword: "",
            newPassword: "",
            confirmNewPassword: "",
            password_length: 0,
            password_typed: false,
            contain_lowercase: false,
            contain_uppercase: false,
            contain_number: false,
            valid_password_length: false,
            valid_password: false,
            modal_title: "",
            gender_list: constantsData.genderTypes,
            field_required:{
                'booking_person_name': '',
                'booking_person_email': '',
                'booking_person_phone':''
            },

            objectNameData: 'this.userdata.',
            objectNameRequire: 'this.field_required.',
            isLoading: false,
            in_charge_of_apartments: '',

            OldPasswordFieldType: "password",
            NewPasswordFieldType:'password',
            ConfirmNewPasswordFieldType: "password",

            iconFieldTypeOldPass:"glyphicon glyphicon-eye-open",
            iconFieldTypeNewPass: "glyphicon glyphicon-eye-open" ,
            iconFieldTypeconfirmNewPass:"glyphicon glyphicon-eye-open",

            BookingStatusEnum: BookingStatusEnum,
            apartment_bookings: {
              booking_id: 0,
              booking_code: "",
              apartment: 0,
              booking_status: BookingStatusEnum.WAITING,
              other_booking_details:"",
              arrived_start_date:null,
              checkin_datetime:null,
              checkout_datetime:null,
              checkout_datetime_origin: null,
              number_of_days:0,
              checkin_yn:false,
              pkg: null,
              booking_company: null,
              booking_person_name	:"",
              booking_person_email :"",
              booking_person_phone:"",
              deposit:0,
              deposit_deadline: null,
              payment_in_advance:0,
              total_deposit: 0,

              // [loitt] - #1171 GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN
              company_name: "",
              company_address: "",
              company_tax_code: "",
              company_email: "",
              has_breakfast: false,

              // [loitt] - #838
              booking_room_rate: 0,
              booking_room_rate_after_discount: 0,
              total_booking_room_rate_after_vat: 0,
              booking_room_rate_after_vat: 0,
              discount: 0,
              sale_off: 0,
              package_price_in_day: 0,
              package_summary: 0,
              modal_booking_room_rate: 0,
              modal_package_price_in_day: 0,
              booking_room_rate_backup: 0,
              ew_included: true,
              payment_duration_factor:1,
              start_e: 0,
              start_w: 0,
              pkg_other_detail: null,
              pkg_other_fee: 0,
              pkg_other_fee_vat: 0,
              total_pkg_other_fee_after_vat: 0, 
              package_price_in_day_after_discount: 0,
              pkg_other_vat: 0,
              vat: 0,

              initialize_deposit_request_from_db: 0 ,
              deposit_request: 0,
              payment_inadvance_request: 0,
            },
            apartment_booking_status_date: {
              apartment : 0,
              date_time: new Date(),
              available_yn:true,
              apt_booking:null
            },
            list_apartment_lease_back_clients_selected:[],
            on_deleted_apartment_lease_back_client: "",
            apartment_leaseback_clients: {
              id : 0,
              id_passsport: null,
              id_passsport_issued_date: null,
              dob: null,
              full_name: null,
              address: null,
              email: null,
              phone: null,
              gender: 1,
              country_code: null,
              other_details: null,
              visa_number: '',
              visa_expired_date: null,
              vn_tmp_stay_start: null,
              vn_tmp_stay_end: null,
              represent: '',
              checkin_datetime: null,
              checkout_datetime: null,
              flight: ''
            },
            paymentDurationFactor: constantsData.paymentDurationFactor,
            data_booking: [],
            hour_default_checkin: null,
            minute_default_checkin: null,
            hour_default_checkout: null,
            minute_default_checkout: null,
            isCopyBooking: null,
            is_view_only: false
        };
    },

    watch: {
      apartment_id: function() {
        if (parseInt(this.apartment_id) !== 0 && (this.booking_id == 0 || utils.isNull(this.booking_id))) {
          const data = {
            id: this.apartment_id
          }
          this.GET_APARTMENT_METERDEVICES(data).then(
            function(res){
              res.forEach(v => {
                if (v.property_type === 1) {
                  // Điện
                  this.apartment.electric_value = v.amount
                  this.apartment_bookings.start_e = v.amount
                } else if (v.property_type === 2) {
                  // Nước
                  this.apartment.water_value = v.amount
                  this.apartment_bookings.start_w = v.amount
                }
              })
            }.bind(this)
          )
        }
      },
      APARTMENT_DETAIL_DATA: function() {
        this.apartment.apartment_code = this.APARTMENT_DETAIL_DATA.apartment_code;
        this.apartment.size = !utils.isNull(this.APARTMENT_DETAIL_DATA.size) ? this.APARTMENT_DETAIL_DATA.size : 0
        this.apartment.bedroom_count = !utils.isNull(this.APARTMENT_DETAIL_DATA.bedroom_count) ? this.APARTMENT_DETAIL_DATA.bedroom_count : 0
        this.apartment.bathroom_count = !utils.isNull(this.APARTMENT_DETAIL_DATA.bathroom_count) ? this.APARTMENT_DETAIL_DATA.bathroom_count : 0
        this.apartment.room_count = !utils.isNull(this.APARTMENT_DETAIL_DATA.room_count) ? this.APARTMENT_DETAIL_DATA.room_count : 0
      },
      GET_BOOKING_DETAIL_DATA: function() {
        this.apartment_bookings.pkg_other_vat = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].other_vat ? this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].other_vat : 0
        let booking_room_rate = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].booking_room_rate
        let sale_off = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.sale_off
        let discount = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.discount
        let package_price_in_day = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].booking_room_rate_daily
        let has_breakfast = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].has_breakfast
        let deposit = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.deposit
        let payment_in_advance = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.payment_in_advance
        let payment_duration_factor = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].payment_duration_factor
        this.apartment_bookings.payment_duration_factor = payment_duration_factor
        this.apartment_bookings.booking_id = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.id
        this.apartment_bookings.booking_code = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.booking_code
        this.apartment_bookings.apartment = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].apartment
        this.apartment_bookings.booking_status = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.booking_status
        this.apartment_bookings.other_booking_details = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.other_booking_details
        this.apartment_bookings.arrived_start_date = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.arrived_start_date

        // [loitt] - #1171 GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN
        this.apartment_bookings.company_name = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.company_name
        this.apartment_bookings.company_address = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.company_address
        this.apartment_bookings.company_tax_code = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.company_tax_code
        this.apartment_bookings.company_email = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.company_email

        // [loitt] - fixed error format from moment(date, format default)
        this.apartment_bookings.checkin_datetime = this.isCopyBooking ? this.$route.query.checkin_datetime : utils.addTimeZoneForTimestamp(this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.checkin_datetime, this.options.format)
        this.getDepositDeadline(this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.checkin_datetime, this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.deposit_deadline)
        // [loitt] - fixed error format from moment(date, format default)
        this.apartment_bookings.checkout_datetime = this.isCopyBooking ? this.$route.query.checkout_datetime : utils.addTimeZoneForTimestamp(this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.checkout_datetime, this.options.format)
        this.apartment_bookings.checkout_datetime_origin = utils.addTimeZoneForTimestamp(this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.checkout_datetime, this.options.format)
        this.apartment_bookings.number_of_days = 0
        this.apartment_bookings.checkin_yn = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.checkin_yn
        this.apartment_bookings.pkg = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].pkg_template
        this.apartment_bookings.booking_company = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.booking_company
        this.apartment_bookings.booking_person_name = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.booking_person_name
        this.apartment_bookings.booking_person_email = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.booking_person_email
        this.apartment_bookings.booking_person_phone = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.booking_person_phone
        this.apartment_bookings.deposit = utils.formatNumber(deposit)
        this.apartment_bookings.payment_in_advance = utils.formatNumber(payment_in_advance)
        this.apartment_bookings.booking_room_rate = utils.formatNumber(booking_room_rate)
        this.apartment_bookings.booking_room_rate_after_discount = utils.formatNumber(Math.round(booking_room_rate - (booking_room_rate * sale_off / 100)))
        this.apartment_bookings.discount = utils.formatNumber(discount)
        this.apartment_bookings.sale_off = sale_off
        this.apartment_bookings.package_price_in_day = utils.formatNumber(package_price_in_day)
        this.apartment_bookings.has_breakfast = has_breakfast
        this.apartment_bookings.package_price_in_day_after_discount = utils.formatNumber(Math.round(package_price_in_day - (package_price_in_day * sale_off / 100)))
        this.apartment_bookings.package_summary = utils.formatNumber(Math.round(this.getTotal(booking_room_rate, sale_off, discount)))
        // Electric
        this.apartment_bookings.start_e = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].start_e
        // Water
        this.apartment_bookings.start_w = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].start_w
        // Electric
        this.apartment.electric_value = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].start_e
        // Water
        this.apartment.water_value = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].start_w
        // Price with vat
        this.apartment_bookings.booking_room_rate_after_vat = utils.formatNumber(Math.round(Math.round(this.getTotal(booking_room_rate, sale_off, discount)) * this.apartment_bookings.vat / 100))
        // Total price after vat
        this.apartment_bookings.total_booking_room_rate_after_vat = utils.formatNumber(Number(utils.formatInteger(this.apartment_bookings.booking_room_rate_after_vat.toString())) + Math.round(this.getTotal(booking_room_rate, sale_off, discount)))
        // #1153: cho phep edit tra truoc, dat coc tra truoc
        this.apartment_bookings.deposit_request =  utils.formatNumber(Math.round(this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.deposit_request))
        this.apartment_bookings.payment_inadvance_request = utils.formatNumber(Math.round(this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.payment_inadvance_request))
        // Total deposit
        this.apartment_bookings.total_deposit = utils.formatNumber(Math.round(this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.deposit_request) + Math.round(this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.payment_inadvance_request))
        this.apartment_bookings.modal_booking_room_rate = booking_room_rate
        this.apartment_bookings.modal_package_price_in_day = package_price_in_day
        this.apartment_bookings.booking_room_rate_backup = booking_room_rate
        this.apartment_bookings.ew_included = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.ew_included
        this.apartment_bookings.pkg_other_detail = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].other_details
        this.apartment_bookings.pkg_other_fee = this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].other_fee ? utils.formatNumber(this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_mapping_with_booking_ids[0].other_fee) : 0
        this.apartment_bookings.pkg_other_fee_vat = utils.formatNumber(utils.formatInteger(this.apartment_bookings.pkg_other_fee.toString()) * this.apartment_bookings.pkg_other_vat / 100)
        this.apartment_bookings.total_pkg_other_fee_after_vat = utils.formatNumber(Number(utils.formatInteger(this.apartment_bookings.pkg_other_fee_vat.toString())) + Number(utils.formatInteger(this.apartment_bookings.pkg_other_fee.toString())))
        // booking clients
        let list_apartment_lease_back_clients_selected = []
        this.GET_BOOKING_DETAIL_DATA.apartment_booking_detail.apartment_lease_back_clients_ids.forEach(v => {
          if (v.main_contact) {
            v.client_details['selected'] = true
          } else {
            v.client_details['selected'] = false
          }
          list_apartment_lease_back_clients_selected.push(v.client_details)
        })
        let main_contact = false
        for (let i = 0, size = list_apartment_lease_back_clients_selected.length; i < size; i++) {
          main_contact = list_apartment_lease_back_clients_selected[i].selected
        }
        if (!main_contact) {
          if (list_apartment_lease_back_clients_selected.length != 0) {
            list_apartment_lease_back_clients_selected[0]['selected'] = true
          }
        }
        this.list_apartment_lease_back_clients_selected = list_apartment_lease_back_clients_selected
      },
      get_number_of_days: function() {
        // Calculator tax
        this.apartment_bookings.booking_room_rate_after_vat = utils.formatNumber(Math.round(this.getTotal(utils.formatInteger(this.apartment_bookings.booking_room_rate.toString()), this.apartment_bookings.sale_off, utils.formatInteger(this.apartment_bookings.discount.toString())) * this.apartment_bookings.vat / 100))
        // Get total after change number of days
        this.apartment_bookings.package_summary = this.getTotal(utils.formatInteger(this.apartment_bookings.booking_room_rate.toString()), this.apartment_bookings.sale_off, utils.formatInteger(this.apartment_bookings.discount.toString()));
        this.apartment_bookings.package_summary = utils.formatNumber(Math.round(this.apartment_bookings.package_summary))
      }
    },

    computed: {
      ...mapGetters([
        "GET_SNACK_BAR",
        "GET_ACCOUNT_DATA",
        "GET_RESIDENT_DATA",
        "APARTMENT_DETAIL_DATA",
        "GET_BOOKING_DETAIL_DATA",
        "GET_LEASEBACK_COMPANY_DATA"
      ]),
      privilegeOptions: function () {
        return this.privilege.customer;
      },
      get_number_of_days: function() {
        let checkin = utils.formatSqlDate(this.apartment_bookings.checkin_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
        let checkout = utils.formatSqlDate(this.apartment_bookings.checkout_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
        let number_of_days = utils.datediff(checkin, checkout) == 'NaN' ? 0 : utils.datediff(checkin, checkout);
        return number_of_days
      },
    },

    methods: {
        ...mapActions([
            "ERROR_TOAST",
            "SUCCESS_TOAST",
            "ON_SHOW_TOAST",
            "GET_COUNTRY_LIST",
            "ADD_APARTMENT_BOOKINGS",
            "UPDATE_APARTMENT_BOOKINGS",
            "GET_LEASEBACK_COMPANY_LIST",
            "GET_APARTMENT_LEASEBACK_CLIENTS_LIST",
            "ADD_APARTMENT_LEASEBACK_CLIENTS",
            "UPDATE_APARTMENT_LEASEBACK_CLIENTS",
            "GET_BOOKING_DETAIL",
            "GET_BOOKING_APARTMENT_DETAIL",
            "GET_APARTMENT_METERDEVICES",
            "CANCEL_APARTMENT_BOOKING",
            "GET_PROJECT_DETAIL"
        ]),
        ...mapActions("bookingModule", [
          // "SEND_EMAIL_CONFIRMED_BOOKING",
        ]),
        selectMainContact: function(item) {
          for (let i = 0, size = this.list_apartment_lease_back_clients_selected.length; i < size; i++) {
            if (item.id != this.list_apartment_lease_back_clients_selected[i].id) {
              this.list_apartment_lease_back_clients_selected[i].selected = false
            } else {
              this.list_apartment_lease_back_clients_selected[i].selected = true
            }
          }
        },
        getCountryName: function(country_id) {
          for (let i = 0, size = this.country_list.length; i < size; i++) {
            if (country_id == this.country_list[i].value) {
              return this.country_list[i].text
            }
          }
        },
        formatDateTimeWithHour: function(dateTime, fromFormat, toFormat) {
          if (!utils.isNull(dateTime)) {
            return utils.formatDateTimeWithHour(dateTime, fromFormat, toFormat)
          }
        },
        formatDateTime: function(dateTime, fromFormat, toFormat) {
          if (!utils.isNull(dateTime)) {
            return utils.formatDateTime(dateTime, fromFormat, toFormat)
          }
        },
        formatNumber: function(n){
          return utils.formatNumber(n)
        },
        formatInteger: function(n){
          return utils.formatInteger(n.toString())
        },
        onConfirmApartmentBooking: function() {
          this.waitingLoading(true)
          $("#modal-confirm-apartment-booking").modal("hide")
          if (this.booking_id == 0 || this.isCopyBooking) {
            this.ADD_APARTMENT_BOOKINGS(this.data_booking).then(
              function (res) {
                this.waitingLoading(false)
                this.SUCCESS_TOAST()
                // this.ON_SHOW_TOAST({
                //   message: this.$t('customer.booking_successfully'),
                //   styleType: "success"
                // });
                this.callBackToList()
              }.bind(this)
            ).catch(
              function (error) {
                this.waitingLoading(false)
                this.SUCCESS_TOAST()
                // this.ON_SHOW_TOAST({
                //   message: error.response.data.non_field_errors[0],
                //   styleType: "danger"
                // })
              }.bind(this)
            );
          } else {
            const data = {
              id: this.booking_id,
              data: this.data_booking
            }
            this.UPDATE_APARTMENT_BOOKINGS(data).then(
              function(res){
                this.waitingLoading(false)
                this.ON_SHOW_TOAST({
                  message: this.$t('customer.booking_successfully'),
                  styleType: "success"
                });
                this.callBackToList()
              }.bind(this)
            ).catch(
              function (error) {
                this.waitingLoading(false)
                let error_message = error.response.data
                if('other_booking_details' in error_message){
                  this.ON_SHOW_TOAST({
                    message: this.$t('apartmentbookings.apartment_leaseback_clients.error.other_booking_details'),
                    styleType: "danger"
                  })
                } else if('apartment_mapping_with_booking_ids' in error_message){
                  this.ON_SHOW_TOAST({
                    message: this.$t('apartmentbookings.apartment_leaseback_clients.error.apartment_mapping_with_booking_ids_other_details'),
                    styleType: "danger"
                  })
                } {
                  this.ON_SHOW_TOAST({
                    message: error.response.data.non_field_errors[0],
                    styleType: "danger"
                  })
                }
              }.bind(this)
            );
          }
        },
        confirmCancelApartmentBooking: function() {
          this.waitingLoading(true)
          $("#modal-cancel-apartment-booking").modal("hide");
          this.CANCEL_APARTMENT_BOOKING({id: this.booking_id, other_booking_details: this.apartment_bookings.other_booking_details}).then(
            function(res) {
              this.waitingLoading(false)
              this.SUCCESS_TOAST()
              this.callBackToList()
            }.bind(this)
          ).catch(
            function(error) {
              let error_code = error.response.data.error_code
              if (error_code == 'is_canceled_out') {
                this.waitingLoading(false)
                this.ON_SHOW_TOAST({
                  message: "Bạn đã hủy đặt phòng rồi.",
                  styleType: "danger"
                })
                this.callBackToList()
              } else if (error_code == 'is_checked_in') {
                this.waitingLoading(false)
                this.ON_SHOW_TOAST({
                  message: "Bạn Đã Nhận Phòng Nên Không Thể Hủy Đặt Phòng.",
                  styleType: "danger"
                })
                this.callBackToList()
              } else if (error_code == 'is_checked_out') {
                this.waitingLoading(false)
                this.ON_SHOW_TOAST({
                  message: "Bạn Đã Trả Phòng Nên Không Thể Hủy Đặt Phòng.",
                  styleType: "danger"
                })
                this.callBackToList()
              } else {
                this.waitingLoading(false)
                this.ERROR_TOAST()
              }
            }.bind(this)
          )
        },
        getDepositDeadline: function(checkin_datetime, deposit_deadline) {
          if (utils.isNull(deposit_deadline)) {
            let checkin = utils.formatSqlDate(checkin_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
            let booking_date = moment(new Date(), "DD/MM/YYYY").format("MM/DD/YYYY")
            let number_of_days = utils.datediff(booking_date, checkin) == 'NaN' ? 0 : utils.datediff(booking_date, checkin);
            if (number_of_days > 7) {
              this.apartment_bookings.deposit_deadline = moment(checkin_datetime, "DD/MM/YYYY").subtract(7, 'days')
            } else if (number_of_days > 2) {
              this.apartment_bookings.deposit_deadline = moment(checkin_datetime, "DD/MM/YYYY").subtract(2, 'days')
            } else if (number_of_days > 1) {
              this.apartment_bookings.deposit_deadline = moment(checkin_datetime, "DD/MM/YYYY").subtract(1, 'days')
            } else {
              this.apartment_bookings.deposit_deadline = moment(new Date(), "DD/MM/YYYY").format("DD/MM/YYYY")
            }
          } else {
            this.apartment_bookings.deposit_deadline = utils.formatSqlDate(deposit_deadline, null, "DD/MM/YYYY")
          }
        },
        onClickShowInvoiceGeneralInvoiceDeposit: function(){
          // call function from model (To set value call back from BOOKING)
          this.$refs.modalInvoiceGeneralInvoiceDetail.setCallBackFrom("BOOKING")
          let object_data_default = {
            amount: 0,
            customer: this.apartment_bookings.booking_person_name,
            description: "Đặt Cọc Cho Mã Booking " + this.apartment_bookings.booking_code,
            purpose: 1, // 1. booking_deposit (phiếu thu tiền đặt coc)
            correlation_key: this.apartment_bookings.booking_code,
            deposit_deadline: this.apartment_bookings.deposit_deadline,
            booking_code: this.apartment_bookings.booking_code
          }
          this.$refs.modalInvoiceGeneralInvoiceDetail.setValueDefault(object_data_default)
          // Show invoice general invoice
          this.$refs.modalInvoiceGeneralInvoiceDetail.submit(0);
        }, 

        onClickShowInvoiceGeneralInvoicePaymentInAdvance: function(){
          // call function from model (To set value call back from BOOKING)
          this.$refs.modalInvoiceGeneralInvoiceDetail.setCallBackFrom("BOOKING")
          let object_data_default = {
            amount: 0,
            customer: this.apartment_bookings.booking_person_name,
            description: "Tiền Trả Trước Cho Mã Booking " + this.apartment_bookings.booking_code,
            purpose: 2, // 2. booking_paymentinadvance (phiếu thu tiền trả trước)
            correlation_key: this.apartment_bookings.booking_code,
            deposit_deadline: this.apartment_bookings.deposit_deadline,
            booking_code: this.apartment_bookings.booking_code
          }
          this.$refs.modalInvoiceGeneralInvoiceDetail.setValueDefault(object_data_default)
          // Show invoice general invoice
          this.$refs.modalInvoiceGeneralInvoiceDetail.submit(0);
        }, 

        onClickShowInvoiceGeneralInvoicePaymentInService: function(){
          // call function from model (To set value call back from BOOKING)
          this.$refs.modalInvoiceGeneralInvoiceDetail.setCallBackFrom("BOOKING")
          let object_data_default = {
            amount: this.apartment_bookings.payment_in_advance,
            customer: this.apartment_bookings.booking_person_name,
            description: "Tiền Trước Cho Mã Booking <<..." + this.apartment_bookings.booking_code + "...>>",
            purpose: 4, // 4. service_payment (sử dụng dịch vụ)
            correlation_key: this.apartment_bookings.booking_code,
            deposit_deadline: this.apartment_bookings.deposit_deadline,
            booking_code: this.apartment_bookings.booking_code
          }
          this.$refs.modalInvoiceGeneralInvoiceDetail.setValueDefault(object_data_default)
          // Show invoice general invoice
          this.$refs.modalInvoiceGeneralInvoiceDetail.submit(0);
        }, 

        // #APARTMENT_INFO - #1243: HIỆN THỰC THÊM CHỨC NĂNG ĐỔI PHÒNG OR COPY THÔNG TIN BOOKING
        // Click show modal
        // Author: [loitt]
        onClickShowEditApartmentInfo: function(){

          if(this.apartment_id != null){
            // call function from model (To set value call back from BOOKING)
            this.$refs.modalUpdateApartmentInfo.setCallBackFrom("BOOKING")
            let object_data_default = {

              apartment_id: this.apartment_id,
              package_id: this.apartment_bookings.pkg,
              check_in:this.apartment_bookings.checkin_datetime,
              check_out:this.apartment_bookings.checkout_datetime

            }
            this.$refs.modalUpdateApartmentInfo.setValueDefault(object_data_default)
            // Show invoice general invoice
            this.$refs.modalUpdateApartmentInfo.submit(0);
          } else {
            this.ON_SHOW_TOAST({
                  message: "Mã Căn Hộ NULL",
                  styleType: "danger"
                });
          }

          
        }, 

        // #APARTMENT_INFO - #1243: HIỆN THỰC THÊM CHỨC NĂNG ĐỔI PHÒNG OR COPY THÔNG TIN BOOKING
        // Event call after press button Save from modal
        // Refresh all info and set new value
        // Author: [loitt]
        onUpdateApartmentInfoSuccess: function(data){
          
          if (data.rom_apartment_id_changed != 0 && data.rom_apartment_id_changed != null) {
            // Changed Room
            this.apartment_id = data.rom_apartment_id_changed
          }
          
          // Changed Eletronic
          this.apartment_bookings.start_e = data.electric_value
          // Changed Water
          this.apartment_bookings.start_w = data.water_value

          if(data.pkg != 0){
            // Changed Package
            this.apartment_bookings.pkg = data.pkg.id
            // Update value the same select service
            this.onPackageOneMonthObject(data.packageOneMonthObject)
            this.onPackageCurrent(data.packageCurrent)
            this.onChangeSelect(data.pkg)
          }
          
        },
        onInvoiceGeneralInvoiceSuccess: function(){
          // alert OK
          this.getBookingDetails()
        },
        onChangeDepositDate: function() {
          // Todo
        },
        sendEmailConfirmedBooking() {
          let routeData = this.$router.resolve({
            name: "ConfirmedApartmentBookingPdf",
            params: {
              id: this.booking_id
            }
          });
          window.open(routeData.href, "_blank");
        },
        onBookingOtherFeeChange(){
          let pkg_other_fee = []
          pkg_other_fee.push(utils.formatInteger(this.apartment_bookings.pkg_other_fee.toString()))
          this.apartment_bookings.pkg_other_fee_vat = utils.formatNumber(pkg_other_fee[pkg_other_fee.length - 1] * this.apartment_bookings.pkg_other_vat / 100)
          this.apartment_bookings.pkg_other_fee = utils.formatNumber(pkg_other_fee[pkg_other_fee.length - 1])
          this.apartment_bookings.total_pkg_other_fee_after_vat = utils.formatNumber(Number(utils.formatInteger(this.apartment_bookings.pkg_other_fee_vat.toString())) + Number(utils.formatInteger(this.apartment_bookings.pkg_other_fee.toString())))
        },
        onChangeElectronic(){
        },
        onChangeWater(){
        },
        formatDeposit() {
          let deposits =[]
          deposits.push(utils.formatInteger(this.apartment_bookings.deposit.toString()))
          this.apartment_bookings.deposit = utils.formatNumber(deposits[deposits.length - 1])
        },
        formatPaymentInAdvance() {
          let PaymentInAdvances =[]
          PaymentInAdvances.push(utils.formatInteger(this.apartment_bookings.payment_in_advance.toString()))
          this.apartment_bookings.payment_in_advance = utils.formatNumber(PaymentInAdvances[PaymentInAdvances.length - 1])
        },
        onCheckIn: function() {
          // To be continue
        },
        onPrintPdfApartmentLeasebackClients(){
          
          let name = "ApartmentLeasebackClientsPrintPdf";

          let routeData = this.$router.resolve({
            name: name,
            params: {
              id: this.apartment_bookings.booking_id
            }
          });
          window.open(routeData.href, "_blank");
        },
        onSaveApartmentLeasebackClients(){
          // Check-in date time with hour
          let checkin_datetime_with_hour = !utils.isNull(this.apartment_leaseback_clients.checkin_datetime) ? moment(this.apartment_leaseback_clients.checkin_datetime, 'DD/MM/YYYY HH:mm').set({hour: this.hour_default_checkin, minutes: this.minute_default_checkin}).format('YYYY-MM-DD HH:mm') : null
          // Check-out date time with hour
          let checkout_datetime_with_hour = !utils.isNull(this.apartment_leaseback_clients.checkout_datetime) ? moment(this.apartment_leaseback_clients.checkout_datetime, 'DD/MM/YYYY HH:mm').set({hour: this.hour_default_checkout, minutes: this.minute_default_checkout}).format('YYYY-MM-DD HH:mm') : null
          // Check-in date time
          let checkin_datetime = utils.formatSqlDate(this.apartment_leaseback_clients.checkin_datetime, 'DD/MM/YYYY HH:mm', 'YYYY-MM-DD HH:mm')
          // Check-out date time
          let checkout_datetime = utils.formatSqlDate(this.apartment_leaseback_clients.checkout_datetime, 'DD/MM/YYYY HH:mm', 'YYYY-MM-DD HH:mm')
          // Check-in date time expected
          let checkin_datetime_expected = !utils.isNull(this.apartment_bookings.checkin_datetime) ? moment(this.apartment_bookings.checkin_datetime, 'DD/MM/YYYY').set({hour: this.hour_default_checkin, minutes: this.minute_default_checkin}).format('YYYY-MM-DD HH:mm') : null
          // Check-out date time expected
          let checkout_datetime_expected = !utils.isNull(this.apartment_bookings.checkout_datetime) ? moment(this.apartment_bookings.checkout_datetime, 'DD/MM/YYYY').set({hour: this.hour_default_checkout, minutes: this.minute_default_checkout}).format('YYYY-MM-DD HH:mm') : null
          if (utils.isNull(this.apartment_leaseback_clients.full_name) || (!utils.isNull(this.apartment_leaseback_clients.full_name) && this.apartment_leaseback_clients.full_name == "")) {
            this.ON_SHOW_TOAST({
              message: "Vui lòng nhập họ và tên",
              styleType: "danger"
            })
          } else if ((!utils.isNull(this.apartment_leaseback_clients.checkin_datetime) || !utils.isNull(this.apartment_leaseback_clients.checkout_datetime)) && checkin_datetime < checkin_datetime_expected) {
            this.ON_SHOW_TOAST({
              message: this.$t('apartmentbookings.apartment_leaseback_clients.checkin_less_checkin_expected'),
              styleType: "danger"
            })
          } else if ((!utils.isNull(this.apartment_leaseback_clients.checkin_datetime) || !utils.isNull(this.apartment_leaseback_clients.checkout_datetime)) && checkin_datetime > checkout_datetime_expected) {
            this.ON_SHOW_TOAST({
              message: this.$t('apartmentbookings.apartment_leaseback_clients.checkin_greater_checkin_expected'),
              styleType: "danger"
            })
          } else if ((!utils.isNull(this.apartment_leaseback_clients.checkin_datetime) || !utils.isNull(this.apartment_leaseback_clients.checkout_datetime)) && checkout_datetime < checkin_datetime_expected) {
            this.ON_SHOW_TOAST({
              message: this.$t('apartmentbookings.apartment_leaseback_clients.checkout_less_checkin_expected'),
              styleType: "danger"
            })
          } else if ((!utils.isNull(this.apartment_leaseback_clients.checkin_datetime) || !utils.isNull(this.apartment_leaseback_clients.checkout_datetime)) && checkout_datetime > checkout_datetime_expected) {
            this.ON_SHOW_TOAST({
              message: this.$t('apartmentbookings.apartment_leaseback_clients.checkout_greater_checkout_expected'),
              styleType: "danger"
            })
          } else if ((!utils.isNull(this.apartment_leaseback_clients.checkin_datetime) || !utils.isNull(this.apartment_leaseback_clients.checkout_datetime)) && checkin_datetime_with_hour > checkout_datetime_with_hour) {
            this.ON_SHOW_TOAST({
              message: this.$t('apartmentbookings.apartment_leaseback_clients.invalid_checkin'),
              styleType: "danger"
            })
          } else {
            let data = {
              id:this.apartment_leaseback_clients.id,
              full_name: this.apartment_leaseback_clients.full_name,
              first_name: "",
              last_name: "",
              email: this.apartment_leaseback_clients.email,
              dob: utils.formatSqlDate(this.apartment_leaseback_clients.dob, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"),
              phone: this.apartment_leaseback_clients.phone,
              gender: this.apartment_leaseback_clients.gender,
              address: this.apartment_leaseback_clients.address,
              other_details: this.apartment_leaseback_clients.other_details,
              id_passsport: this.apartment_leaseback_clients.id_passsport,
              id_passsport_issued_date: utils.formatSqlDate(this.apartment_leaseback_clients.id_passsport_issued_date, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"),
              visa_number: this.apartment_leaseback_clients.visa_number,
              visa_expired_date: new Date(utils.formatSqlDate(this.apartment_leaseback_clients.visa_expired_date, "DD-MM-YYYY", "YYYY-MM-DD")),
              vn_tmp_stay_start: new Date(utils.formatSqlDate(this.apartment_leaseback_clients.vn_tmp_stay_start, "DD-MM-YYYY", "YYYY-MM-DD")),
              vn_tmp_stay_end: new Date(utils.formatSqlDate(this.apartment_leaseback_clients.vn_tmp_stay_end, "DD-MM-YYYY", "YYYY-MM-DD")),
              represent: this.apartment_leaseback_clients.represent,
              country: this.apartment_leaseback_clients.country_code,
              // Checkin
              checkin_datetime: !utils.isNull(this.apartment_leaseback_clients.checkin_datetime) ? new Date(moment(this.apartment_leaseback_clients.checkin_datetime, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm")) : new Date(moment(checkin_datetime_expected).format("YYYY-MM-DDTHH:mm")),
              // Checkout
              checkout_datetime: !utils.isNull(this.apartment_leaseback_clients.checkout_datetime) ? new Date(moment(this.apartment_leaseback_clients.checkout_datetime, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm")) : new Date(moment(checkout_datetime_expected).format("YYYY-MM-DDTHH:mm")),
              flight: this.apartment_leaseback_clients.flight
            };
            if(this.apartment_leaseback_clients.id == 0){
              this.ADD_APARTMENT_LEASEBACK_CLIENTS(data)
              .then(
                  function (res) {
                      this.waitingLoading(false)
                      this.ON_SHOW_TOAST({
                          message: this.$t("apartmentbookings.apartment_leaseback_clients.created"),
                          styleType: "success"
                      });
                      // update ID
                      data.id = res.id
                      this.list_apartment_lease_back_clients_selected.push(data)
                      if (this.list_apartment_lease_back_clients_selected.length == 1) {
                        data['selected'] = true
                        this.list_apartment_lease_back_clients_selected[0]['selected'] = true
                      }
                      this.resetDataApartmentLeasebackClients()
                  }.bind(this)
              )
              .catch(
                  function (error) {
                      let error_message = error.response.data.message
                      if('other_details' in error.response.data){
                        this.ON_SHOW_TOAST({
                          message: this.$t('apartmentbookings.apartment_leaseback_clients.error.apartment_leaseback_clients_note'),
                          styleType: "danger"
                        })
                      } else if(error_message.includes('duplicate_identificationnumber_passport')){ 
                        this.ON_SHOW_TOAST({
                                  message: this.$t('apartmentbookings.apartment_leaseback_clients.duplicate_identificationnumber_passport'),
                                  styleType: "danger"
                              })
                      } else {
                        {
                          this.ON_SHOW_TOAST({
                                message: error_message,
                                styleType: "danger"
                            })
                          }
                      }
                  }.bind(this)
              )
            } else {
              this.UPDATE_APARTMENT_LEASEBACK_CLIENTS({id: data.id, ...data})
              .then(
                  function (res) {
                      this.waitingLoading(false)
                      this.ON_SHOW_TOAST({
                          message: this.$t("apartmentbookings.apartment_leaseback_clients.edited"),
                          styleType: "success"
                      });
                      this.resetDataApartmentLeasebackClients()
                  }.bind(this)
              )
              .catch(
                  function (error) {
                      let error_message = error.response.data.message
                      if(error_message.includes('other_details')){
                        
                        this.ON_SHOW_TOAST({
                          message: this.$t('apartmentbookings.apartment_leaseback_clients.error.apartment_leaseback_clients_note'),
                          styleType: "danger"
                        })
                      } else if(error_message.includes('duplicate_identificationnumber_passport')){
                        this.ON_SHOW_TOAST({
                                  message: this.$t('apartmentbookings.apartment_leaseback_clients.duplicate_identificationnumber_passport'),
                                  styleType: "danger"
                              })
                      } else {
                        {
                          this.ON_SHOW_TOAST({
                                message: error_message,
                                styleType: "danger"
                            })
                          }
                      }
                  }.bind(this)
              )
            }
          }
        },

        /**
          Author: [loitt]
          Event: Rset Apartment Leaseback Clients
          # Input : None
          # Output: Reset data this.apartment_leaseback_clients
        */
        onResetApartmentLeasebackClients(){
          // alert("apartmentLeasebackClientsReset")
          this.resetDataApartmentLeasebackClients()
        },

        /**
          Author: [loitt]
          function: resetDataApartmentLeasebackClients
          # Input : None
          # Output: Reset data this.apartment_leaseback_clients
        */
        resetDataApartmentLeasebackClients(){
          let data = {
            id : 0,
            id_passsport: null,
            id_passsport_issued_date: null,
            dob: null,
            full_name: null,
            address: null,
            email: null,
            phone: null,
            gender: 1,
            country_code: null,
            other_details: null,
            checkin_datetime: null,
            checkout_datetime: null
          }
          this.apartment_leaseback_clients = data
        },

        clickEventOpenModalLeasebackClients(){
          // get all user
          const data = {
            params: {
              page: 1
            }
          };
          this.GET_APARTMENT_LEASEBACK_CLIENTS_LIST(data);
          $("#modal-select-client").modal("show");
        },

        doSelectClient(list_apartment_lease_back_clients_selected) {
          list_apartment_lease_back_clients_selected.forEach(v=> {
            v['selected'] = false
            let client_exist = false
            for (let i=0; i < this.list_apartment_lease_back_clients_selected.length; i++){
              let current_client = this.list_apartment_lease_back_clients_selected[i]
              if (v.id == current_client.id) {
                client_exist = true
                break
              }
            }
            if (!client_exist) {
              this.list_apartment_lease_back_clients_selected.push(v)
            }
          })
        },

        /**
          Author: [loitt]
          Ref from : method get_number_of_days
          Method: nget number of days
          # Input :
              checkin_datetime: checkin of datetime
              checkout_datetime: checkout of datetime
          # Output:
              datediff
        */
        number_of_days: function() {
          let checkin = utils.formatSqlDate(this.apartment_bookings.checkin_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
          let checkout = utils.formatSqlDate(this.apartment_bookings.checkout_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
          let number_of_days = utils.datediff(checkin, checkout) == 'NaN' ? 0 : utils.datediff(checkin, checkout);

          return number_of_days
        },

        /**
          Author: [loitt]
          Event: on Booking Room Rate Change on modal
          # Input :
              booking_room_rate: Package Price / Month
              discount: promotion
          # Output:
              modal_package_price_in_day
        */
        onBookingRoomRateChangeModal(){
          this.apartment_bookings.discount = utils.formatInteger(this.apartment_bookings.discount.toString())
          let package_price_in_day = this.calculatorPackagePriceInDay(this.apartment_bookings.modal_booking_room_rate,    this.apartment_bookings.sale_off)
          this.apartment_bookings.modal_package_price_in_day = utils.formatNumber(package_price_in_day)
          let modal_booking_room_rate_list = []
          modal_booking_room_rate_list.push(utils.formatInteger(this.apartment_bookings.modal_booking_room_rate.toString()))
          this.apartment_bookings.modal_booking_room_rate = modal_booking_room_rate_list[modal_booking_room_rate_list.length - 1]
          this.apartment_bookings.modal_booking_room_rate = utils.formatNumber(this.apartment_bookings.modal_booking_room_rate)
          this.apartment_bookings.discount = utils.formatNumber(this.apartment_bookings.discount)
        },

        /**
          Author: [loitt]
          Event: on Booking Room Rate Change
          # Input :
              booking_room_rate: Package Price / Month
              discount: promotion
          # Output:
              modal_package_price_in_day
        */
        onBookingRoomRateChange(){
          let discounts = []
          discounts.push(utils.formatInteger(this.apartment_bookings.discount.toString()))
          let package_price_in_day = this.calculatorPackagePriceInDayAfterDiscount(this.apartment_bookings.booking_room_rate, this.apartment_bookings.sale_off)
          // this.apartment_bookings.package_price_in_day = utils.formatNumber(package_price_in_day)
          this.apartment_bookings.package_price_in_day_after_discount = utils.formatNumber(package_price_in_day)
          let booking_room_rate = utils.formatInteger(this.apartment_bookings.booking_room_rate.toString())
          this.apartment_bookings.booking_room_rate_after_discount = utils.formatNumber(Math.round(booking_room_rate - (booking_room_rate * this.apartment_bookings.sale_off / 100)))
          // calculatortor summary
          this.setPackageSummary(this.apartment_bookings.booking_room_rate, this.apartment_bookings.discount, this.apartment_bookings.sale_off)
          this.apartment_bookings.booking_room_rate_after_vat = utils.formatNumber(Math.round(this.getTotal(utils.formatInteger(this.apartment_bookings.booking_room_rate.toString()), this.apartment_bookings.sale_off, discounts[discounts.length - 1]) * this.apartment_bookings.vat / 100))
          // Calculator total price booking room rate after vat
          this.apartment_bookings.total_booking_room_rate_after_vat = utils.formatNumber(Math.round(Number(this.getTotal(utils.formatInteger(this.apartment_bookings.booking_room_rate.toString()), this.apartment_bookings.sale_off, discounts[discounts.length - 1])) + Number(utils.formatInteger(this.apartment_bookings.booking_room_rate_after_vat.toString()))))
          // [loitt] - #1153: cho phep edit tra truoc, dat coc tra truoc
          // if(utils.formatInteger(this.apartment_bookings.deposit_request.toString()) <= 0){
            this.apartment_bookings.deposit_request = this.apartment_bookings.total_booking_room_rate_after_vat
            this.apartment_bookings.payment_inadvance_request = utils.formatNumber(Math.round(utils.formatInteger(this.apartment_bookings.deposit_request.toString()) * 0.5))
            this.apartment_bookings.total_deposit = utils.formatNumber(Number(utils.formatInteger(this.apartment_bookings.deposit_request.toString())) +
            Number(utils.formatInteger(this.apartment_bookings.payment_inadvance_request.toString()))) 
          // }
          // Format discount
          this.apartment_bookings.discount = utils.formatNumber(discounts[discounts.length - 1])
          if (utils.formatInteger(this.apartment_bookings.total_booking_room_rate_after_vat.toString()) < 0) {
            this.apartment_bookings.total_booking_room_rate_after_vat = 0
            this.apartment_bookings.deposit_request = 0
            this.apartment_bookings.payment_inadvance_request = 0
            this.apartment_bookings.total_deposit = 0
          }
        },
        /**
          Author: [loitt]
          Event: Change from input DepositRequest or PaymentInadvanceRequest
        */
        onChangeDepositRequestOrPaymentInadvanceRequest(){
          let int_deposit_request = utils.formatInteger(this.apartment_bookings.deposit_request.toString())
          // if( int_deposit_request <= 0){
          this.apartment_bookings.deposit_request = utils.formatNumber(int_deposit_request)
          let payment_inadvance_request = utils.formatInteger(this.apartment_bookings.payment_inadvance_request.toString())
          this.apartment_bookings.payment_inadvance_request = utils.formatNumber(payment_inadvance_request)
          this.apartment_bookings.total_deposit = utils.formatNumber(Number(utils.formatInteger(this.apartment_bookings.deposit_request.toString())) + Number(utils.formatInteger(this.apartment_bookings.payment_inadvance_request.toString())))
          // }
        },

        getTotal: function(booking_room_rate, sale_off, discount) {

          //let month = parseInt(this.number_of_days() / 30)
          //let day =  this.number_of_days() % 30
          let booking_room_rate_discount = booking_room_rate * (1 - sale_off / 100)
          //let package_summary = (booking_room_rate_discount * month) + (booking_room_rate_discount / (this.apartment_bookings.payment_duration_factor == 1 ? 30 : this.apartment_bookings.payment_duration_factor == 2 ? 7 : 1) * day) - discount
          let package_summary = (booking_room_rate_discount / (this.apartment_bookings.payment_duration_factor == 1 ? 30 : this.apartment_bookings.payment_duration_factor == 2 ? 7 : 1) * this.number_of_days()) - discount
          // Total booking room rate after vat
          this.apartment_bookings.total_booking_room_rate_after_vat = utils.formatNumber(Math.round(package_summary + Number(utils.formatInteger(this.apartment_bookings.booking_room_rate_after_vat.toString()))))
          // [loitt] - #1153: cho phep edit tra truoc, dat coc tra truoc
          // if(utils.formatInteger(this.apartment_bookings.deposit_request.toString()) <= 0){
            // this.apartment_bookings.deposit_request = this.apartment_bookings.total_booking_room_rate_after_vat
            // this.apartment_bookings.payment_inadvance_request = utils.formatNumber(Math.round(utils.formatInteger(this.apartment_bookings.deposit_request) * 0.5))
          // }
          if (utils.formatInteger(this.apartment_bookings.total_booking_room_rate_after_vat.toString()) < 0) {
            this.apartment_bookings.total_booking_room_rate_after_vat = 0
            this.apartment_bookings.deposit_request = 0
            this.apartment_bookings.payment_inadvance_request = 0
            this.apartment_bookings.total_deposit = 0
          }
          return package_summary
        },
        setPackageSummary: function(booking_room_rate, discount, sale_off){
          if(isNaN(booking_room_rate)){
            booking_room_rate = utils.formatInteger(booking_room_rate);
          }
          if(isNaN(discount)){
            discount = utils.formatInteger(discount);
          }
          if(isNaN(sale_off)){
            sale_off = utils.formatInteger(sale_off);
          }


          let package_summary = this.getTotal(booking_room_rate, sale_off, discount)
          // calculatortor summary
          this.apartment_bookings.package_summary = utils.formatNumber(utils.makeRoundNumber(package_summary)) 
          if (utils.makeRoundNumber(package_summary) < 0) {
            this.apartment_bookings.package_summary = 0
          }
        },

        /**
          Author: [loitt]
          Event: Click Modify
          # Input :
              None
          # Output:
            Show modal change package price
        */
        onClickModify(){
          this.apartment_bookings.modal_package_price_in_day = utils.formatNumber(this.apartment_bookings.modal_package_price_in_day)
          this.apartment_bookings.modal_booking_room_rate = utils.formatNumber(this.apartment_bookings.modal_booking_room_rate)
          $(this.$refs[`modal-main-package-price`]).modal("show");
        },

        /**
          Author: [loitt]
          Event: Click Reset
          # Input :
            booking_room_rate_backup: booking rom rate
            discount: promotion
          # Output:
            Reset all Package Price with data sekect from Service Package Name
        */
        onClickReset(){
          if (this.booking_id == 0) {
            this.initializeBookingRoomRate(this.apartment_bookings.booking_room_rate_backup, utils.formatInteger(this.apartment_bookings.discount.toString()), this.apartment_bookings.sale_off)
          } else {
            this.GET_BOOKING_DETAIL({id: this.booking_id})
          }
        },
        onPackageSelect: function(pkg_id){
          this.apartment_bookings.pkg = pkg_id
        },

        /**
          Author: [loitt]
          Method: calculator Package Price In Day
          # Input :
              booking_room_rate: Package Price / Month
              discount: promotion
          # Output:
              package_price_in_day: Package Price / Day
        */
        calculatorPackagePriceInDay(booking_room_rate, sale_off){
          if(typeof booking_room_rate == "string"){
            booking_room_rate = utils.formatInteger(booking_room_rate)
          }
          let payment_type = this.apartment_bookings.payment_duration_factor == 1 ? 30 : this.apartment_bookings.payment_duration_factor == 2 ? 7 : 1;
          /**
           * Old
           * let package_price_in_day =  utils.makeRoundNumber((booking_room_rate - (booking_room_rate * sale_off / 100)) / payment_type)
           */
          let package_price_in_day =  utils.makeRoundNumber(booking_room_rate / payment_type)
          return package_price_in_day;
        },
        calculatorPackagePriceInDayAfterDiscount(booking_room_rate, sale_off) {
          if(typeof booking_room_rate == "string"){
            booking_room_rate = utils.formatInteger(booking_room_rate)
          }
          let payment_type = this.apartment_bookings.payment_duration_factor == 1 ? 30 : this.apartment_bookings.payment_duration_factor == 2 ? 7 : 1;
          let package_price_in_day =  utils.makeRoundNumber((booking_room_rate - (booking_room_rate * sale_off / 100)) / payment_type)
          return package_price_in_day;
        },
        /**
          Author: [loitt]
          Method: initialize Booking Room Rate
          # Input :
              booking_room_rate: Package Price / Month
              discount: promotion
          # Output:
              Show in : Booking Pric
                package_price_in_day: Package Price / Day
                booking_room_rate: Package Price / Month
                package_summary: Summary
              Show in : Modal
              modal_booking_room_rate: Package Price / Month
              modal_package_price_in_day: Package Price / Day
        */
        initializeBookingRoomRate: function(booking_room_rate, discount, sale_off){
          let package_price_in_day = this.calculatorPackagePriceInDay(booking_room_rate, sale_off)
          let package_price_in_day_after_discount = this.calculatorPackagePriceInDayAfterDiscount(booking_room_rate, sale_off)
          this.apartment_bookings.package_price_in_day = utils.formatNumber(package_price_in_day)
          this.apartment_bookings.package_price_in_day_after_discount = utils.formatNumber(package_price_in_day_after_discount)
          this.apartment_bookings.booking_room_rate = utils.formatNumber(booking_room_rate)
          this.apartment_bookings.booking_room_rate_after_discount = utils.formatNumber(Math.round(utils.formatInteger(booking_room_rate.toString()) - (utils.formatInteger(booking_room_rate.toString()) * sale_off / 100)))
          this.setPackageSummary(booking_room_rate, discount, sale_off)
          // booking room rate after vat
          this.apartment_bookings.booking_room_rate_after_vat = utils.formatNumber(Math.round(this.getTotal(utils.formatInteger(booking_room_rate.toString()), sale_off, discount) * this.apartment_bookings.vat / 100))
          // total booking room rate after vat
          this.apartment_bookings.total_booking_room_rate_after_vat = utils.formatNumber(Math.round(Number(utils.formatInteger(this.apartment_bookings.booking_room_rate_after_vat.toString())) + this.getTotal(utils.formatInteger(booking_room_rate.toString()), sale_off, discount)))
          // [loitt] - #1153: cho phep edit tra truoc, dat coc tra truoc
          if((this.apartment_bookings.initialize_deposit_request_from_db > 1) || (this.apartment_bookings.initialize_deposit_request_from_db == 0)){
              this.apartment_bookings.payment_inadvance_request = this.apartment_bookings.total_booking_room_rate_after_vat
              
              if (this.get_number_of_days >= 30) {
                this.apartment_bookings.deposit_request = utils.formatNumber(Math.round(utils.formatInteger(this.apartment_bookings.payment_inadvance_request.toString()) * 1))
              } else {
                this.apartment_bookings.deposit_request = utils.formatNumber(Math.round(utils.formatInteger(this.apartment_bookings.payment_inadvance_request.toString()) * 0.5))
              }
              this.apartment_bookings.total_deposit = utils.formatNumber(Number(utils.formatInteger(this.apartment_bookings.payment_inadvance_request.toString())) + Number(utils.formatInteger(this.apartment_bookings.deposit_request.toString())))
          }
          if (utils.formatInteger(this.apartment_bookings.total_booking_room_rate_after_vat.toString()) < 0) {
            this.apartment_bookings.total_booking_room_rate_after_vat = 0
            this.apartment_bookings.deposit_request = 0
            this.apartment_bookings.payment_inadvance_request = 0
            this.apartment.total_deposit = 0
          }
          
          // use for model
          this.apartment_bookings.modal_booking_room_rate = booking_room_rate
          this.apartment_bookings.modal_package_price_in_day = package_price_in_day
        },

        /**
          Author: [loitt] -#838
          Event:on Package One Month Object from Service Package Name
          # Input :
              objPackageOneMonth: object Fixed service (1 Month)
          # Output:
              initializeBookingRoomRate()
              booking_room_rate_backup: set package data
        */
       calculatorFeePackageOneMonth: function(objPackageOneMonth) {
          let booking_room_rate = 0
          //let pkg_other_details = null
          if(objPackageOneMonth != null && objPackageOneMonth != undefined && objPackageOneMonth.length > 0){
            this.apartment_bookings.vat = objPackageOneMonth[0].vat
            // Old
              // booking_room_rate = objPackageOneMonth[0].priceAfterVAT
            // New
            // Booking room rate after vat
            this.apartment_bookings.booking_room_rate_after_vat = Math.round(objPackageOneMonth[0].price * (objPackageOneMonth[0].vat / 100))
            booking_room_rate = objPackageOneMonth[0].price
            //pkg_other_details = objPackageOneMonth[0].other_details
            this.apartment_bookings.payment_duration_factor = objPackageOneMonth[0].payment_duration_factor
          }
          //this.apartment_bookings.pkg_other_detail = pkg_other_details
          // initialize_deposit_request_from_db == 0 ==> add new
          // initialize_deposit_request_from_db == 1 ==> load from db
          // initialize_deposit_request_from_db > 1: have change from package
          // console.log(this.apartment_bookings.initialize_deposit_request_from_db)
          // this.apartment_bookings.initialize_deposit_request_from_db = this.apartment_bookings.initialize_deposit_request_from_db + 1
          // console.log(this.apartment_bookings.initialize_deposit_request_from_db)
          this.initializeBookingRoomRate(booking_room_rate, utils.formatInteger(this.apartment_bookings.discount.toString()), this.apartment_bookings.sale_off)
          this.apartment_bookings.booking_room_rate_backup = booking_room_rate
       },
        onPackageOneMonthObject: function(objPackageOneMonth){ // bokking =0 -> add
          this.calculatorFeePackageOneMonth(objPackageOneMonth)
        },
        onPackageCurrent: function(objPackageOneMonth) { // booking #0 -> edit
          if (this.booking_id != 0) {
            if(objPackageOneMonth != null && objPackageOneMonth != undefined && objPackageOneMonth.length > 0){
              this.apartment_bookings.vat = objPackageOneMonth[0].vat
              this.apartment_bookings.booking_room_rate_after_vat = Math.round(utils.formatInteger(this.apartment_bookings.booking_room_rate.toString()) * (objPackageOneMonth[0].vat / 100))
              this.apartment_bookings.payment_duration_factor = this.apartment_bookings.payment_duration_factor
            }
            // initialize_deposit_request_from_db == 0 ==> add new
            // initialize_deposit_request_from_db == 1 ==> load from db
            // initialize_deposit_request_from_db > 1: have change from package
            this.apartment_bookings.initialize_deposit_request_from_db = this.apartment_bookings.initialize_deposit_request_from_db + 1
            this.initializeBookingRoomRate(utils.formatInteger(this.apartment_bookings.booking_room_rate.toString()), utils.formatInteger(this.apartment_bookings.discount.toString()), this.apartment_bookings.sale_off)


            
          }
        },
        onDeleteApartmentLeaseBackClient (item) {
            $('#modal-apartment-leaseback-client-delete').modal('show')
            this.on_deleted_apartment_lease_back_client = item
          },
        onEditApartmentLeaseBackClient(item){
          // Check-in date time
          if (!utils.isNull(item.checkin_datetime)) {
            item.checkin_datetime = utils.formatDateTimeWithHour(item.checkin_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm')
          } else {
            item.checkin_datetime = null
          }
          // Check-out date time
          if (!utils.isNull(item.checkout_datetime)) {
            item.checkout_datetime = utils.formatDateTimeWithHour(item.checkout_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm')
          } else {
            item.checkout_datetime = null
          }
          // Visa expired date
          if (!utils.isNull(item.visa_expired_date)) {
            item.visa_expired_date = utils.formatDateTime(item.visa_expired_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY')
          } else {
            item.visa_expired_date = null
          }
          // Visa stay start
          if (!utils.isNull(item.vn_tmp_stay_start)) {
            item.vn_tmp_stay_start = utils.formatDateTime(item.vn_tmp_stay_start, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY')
          } else {
            item.vn_tmp_stay_start = null
          }
          // Visa stay end
          if (!utils.isNull(item.vn_tmp_stay_end)) {
            item.vn_tmp_stay_end = utils.formatDateTime(item.vn_tmp_stay_end, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY')
          } else {
            item.vn_tmp_stay_end = null
          }
          // Passport due date
          if (!utils.isNull(item.id_passsport_issued_date)) {
            item.id_passsport_issued_date = utils.formatDateTime(item.id_passsport_issued_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY')
          } else {
            item.id_passsport_issued_date = null
          }
          // Dob
          if (!utils.isNull(item.dob)) {
            item.dob = utils.formatDateTime(item.dob, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY')
          } else {
            item.dob = null
          }
          // Country
          if (!utils.isNull(item.country)) {
            this.apartment_leaseback_clients.country_code = item.country
            item.country_code = item.country
          } else {
            this.apartment_leaseback_clients.country_code = null
            item.country_code = null
          }
          this.apartment_leaseback_clients = item
        },
        onConfirmDelete: function(){
          $('#modal-apartment-leaseback-client-delete').modal('hide')
          this.list_apartment_lease_back_clients_selected = this.list_apartment_lease_back_clients_selected.filter(item => item.id != this.on_deleted_apartment_lease_back_client.id)
          let main_contact = false
          if (this.list_apartment_lease_back_clients_selected.length == 1) {
            this.list_apartment_lease_back_clients_selected[0]['selected'] = true
          } else {
            for (let i = 0, size = this.list_apartment_lease_back_clients_selected.length; i < size; i++) {
              if (this.list_apartment_lease_back_clients_selected[i]['selected']) {
                main_contact = true
              }
            }
            if (!main_contact) {
              this.list_apartment_lease_back_clients_selected[0]['selected'] = true
            }
          }
        },

        selectedItemLeaseBackClient: function(){
          return false
          // if (this.selectedEscalationStage == null) {
          //   this.escalation_stage_id = 0
          // } else {
          //   this.escalation_stage_id = this.selectedEscalationStage.id !== 0 ? this.selectedEscalationStage.id : 0
          // }
        },

        // this.$t("customer.error_messages.email_exist")
        showError: function(msg){
            this.ON_SHOW_TOAST({
                message: this.$t(msg),
                styleType: "danger"
            });
        },
        showSuccess: function(msg){
            this.ON_SHOW_TOAST({
                message: this.$t(msg),
                styleType: "success"
            });
        },
        has_perm: function(perm){
            return utils.has_perm(this.GET_ACCOUNT_DATA, perm)
        },
        // add show/hide password
        switchVisibility: function(typePass) {
        if (typePass == 3) {
            this.ConfirmNewPasswordFieldType = this.ConfirmNewPasswordFieldType === "password" ? "text" : "password";
            this.iconFieldTypeconfirmNewPass = this.ConfirmNewPasswordFieldType === "password"
                                                        ? "glyphicon glyphicon-eye-open"
                                                        : "glyphicon glyphicon-eye-close";
        }
        if (typePass == 2){
            this.NewPasswordFieldType = this.NewPasswordFieldType === "password" ? "text" : "password";
            this.iconFieldTypeNewPass = this.NewPasswordFieldType === "password"
                                                        ? "glyphicon glyphicon-eye-open"
                                                        : "glyphicon glyphicon-eye-close";
        }
        if (typePass==1){
            this.OldPasswordFieldType = this.OldPasswordFieldType === "password" ? "text" : "password";
            this.iconFieldTypeOldPass = this.OldPasswordFieldType === "password"
                                                        ? "glyphicon glyphicon-eye-open"
                                                        : "glyphicon glyphicon-eye-close";
        }
        },
        // [loitt] - add validate Email empty and incorrect format
        validateEmailAll: function(field, objectName = 'this.customerdata.',  objectNameRequire = 'this.field_required.' ) {
            // use for get value : this.customer.last_name
            let exec = objectName + field

            // this.field_required.last_name
            let error_msg = objectNameRequire + field

            // Init data befor check
            eval(error_msg + " = ''")

            // ==> get value current
            let result = eval(exec)

            if (result == null || result == "") {
                eval(error_msg + " = 'common.error_msg[0].required'")
            } else {
                let isEmailValid = this.validateEmail(result)
                if(!isEmailValid){
                eval(error_msg + " = 'user.inform_modal[0].email_error'")
                }
            }

            return result;
        },

        // [loitt] - add validate Field Is Empty
        validateFieldIsEmpty: function(field, objectName = 'this.customerdata.',  objectNameRequire = 'this.field_required.' ) {

            // use for get value : this.userdata.last_name
            let exec = objectName + field
            // this.field_required.last_name
            let error_msg = objectNameRequire + field

            // Init data befor check
            eval(error_msg + " = ''")

            // ==> get value current
            let result = eval(exec)

            if (result == null || result == "") {
                eval(error_msg + " = 'common.error_msg[0].required'")
            }

            return result;

        },
        callBackToList: function(){

          this.$router.push({
            name: "LeaseBackAvailableApartmentList",
            query: {
              checkin_datetime: this.$route.query.checkin_datetime,
              checkout_datetime: this.$route.query.checkout_datetime
            }
          });
        },
        CancelCustomerList: function () {
          // [Khanh] function name is incorrect, back to available apartmnt list\
          this.callBackToList()
        },
        validateData: function () {
            let validatedResult = "OK";
            let isEmailValid = this.validateEmail(this.customerdata.email)
            for (let key in this.customerdata) {
                if (
                    key == "crmcode" ||
                    key == "country_code" ||
                    key == "company_name" ||
                    key == "company_address" ||
                    key == "company_tax_code" ||
                    key == "company_email" ||
                    key == "company_phone" ||
                    key == "company_website" ||
                    key == "personal_tax_code" ||
                    key == "url_avatar" ||
                    key == "company_website" ||
                    key == "representative_name" ||
                    key == "representative_email" ||
                    key == "representative_phone" ||
                    key == "representative_identificationnumber" ||
                    key == "representative_passport" ||
                    key == "representative_position" ||
                    key == "passport" ||
                    key == "identificationnumber"
                ) {
                    // not validating 'crmcode' field

                    // validate CMND - # issue 188
                    if( key == "identificationnumber" &&
                        this.customerdata[key] !== null &&
                        this.customerdata[key] !== "") {
                            let lenIdentificationNumber = this.customerdata[key].length
                            if(!(lenIdentificationNumber == 9 || lenIdentificationNumber == 12)){
                                validatedResult = "CMND phải có chiều dài của chuỗi là 9 hoặc 12 ký tự";
                                break;
                            }
                    }

                    // validate passport - # issue 188
                    if( key == "passport" &&
                        this.customerdata[key] !== null &&
                        this.customerdata[key] !== "") {
                            let passport = this.customerdata[key].length
                            if(!(7 < passport && passport < 15)){
                                validatedResult = "Passport phải có chiều dài chuỗi lớn hơn 7 và nhỏ hơn 15";
                                break;
                            }
                    }

                } else if (this.customerdata['phone'] != "" && this.customerdata['phone'] != null) {
                  let isPhoneValid = utils.validatePhone(this.customerdata['phone'].replace(/ /g,''))
                  if (!isPhoneValid) {
                    validatedResult = this.$t('user.inform_modal[0].phone_number_error');
                  }
                } else if (
                    (this.customerdata[key] === null ||
                    this.customerdata[key] === "") && key != "phone" && key !== "username"
                ) {
                    validatedResult = key + " " + this.$t('customer.not_empty');
                } else if (!isEmailValid) {
                    validatedResult = this.$t('user.inform_modal[0].email_error');
                    break;
                }
            }

            // [loitt]  - #395 Check CMND và Hộ Chiếu, thì bắt buộc nhập 1 trong 2
            /*if(this.customerdata.identificationnumber == "" && this.customerdata.passport == ""){
                validatedResult = this.$t('customer.passport_identificationnumber');
            }
            */
            return validatedResult;
        },
        isNumeric(num){
            return !isNaN(num)
        },
        checkForm: function(objectName) {

            let result_error = "OK"
            for (var key in this.field_required)
            {
                if(key === 'email'){
                    this.validateEmailAll(key);
                } else {
                   if(!(key === 'password' && this.$route.query.apartment_id != 0)){
                        this.validateFieldIsEmpty(key, objectName);
                    }
                }
                let key_error = this.objectNameRequire + key
                let  t_result = eval(key_error)
                if( t_result != ''){
                    result_error = t_result
                }
            }

            return result_error
        },
        saveBooking: function (booking_status = null) {
          // [Khanh] function name is incorrect -> this is save booking
          // [loitt] - changed validate data #266
          let result = this.checkForm('this.apartment_bookings.'); // validateData
          if (result == "OK" && this.apartment_bookings.pkg != null && this.apartment_bookings.pkg != -1) {
            if (booking_status != BookingStatusEnum.CANCELLED && booking_status != BookingStatusEnum.ONBOARD) {
              // this.waitingLoading(true)
            }
            let data_booking = {}
            let checkin_datetime = new Date(utils.formatSqlDate(this.apartment_bookings.checkin_datetime, "DD-MM-YYYY", "YYYY-MM-DD"))
            let checkout_datetime = new Date(utils.formatSqlDate(this.apartment_bookings.checkout_datetime, "DD-MM-YYYY", "YYYY-MM-DD"))
            checkin_datetime.setHours(this.hour_default_checkin);
            checkin_datetime.setMinutes(this.minute_default_checkin);
            checkout_datetime.setHours(this.hour_default_checkout);
            checkout_datetime.setMinutes(this.minute_default_checkout);
            let deposit_deadline = new Date(utils.formatSqlDate(this.apartment_bookings.deposit_deadline, "DD-MM-YYYY", "YYYY-MM-DD"))
            let apartment_lease_back_clients_ids = []
            if(this.list_apartment_lease_back_clients_selected.length > 0){
              this.list_apartment_lease_back_clients_selected.forEach(v=> {
                let client_item = {
                  client: v.id,
                  main_contact: v.selected ? v.selected : false
                }
                apartment_lease_back_clients_ids.push(client_item)
              })
            }
            let discount = (this.apartment_bookings.discount == 0) ? 0 : utils.formatInteger(this.apartment_bookings.discount.toString())
            let sale_off = (this.apartment_bookings.sale_off == 0) ? 0 : utils.formatInteger(this.apartment_bookings.sale_off.toString())

            data_booking = {
              "apartmentbookingstatusdate":
                {
                  "apartment":this.$route.query.apartment_id,
                  'date_time':this.apartment_booking_status_date.date_time,
                  'available_yn': this.apartment_booking_status_date.available_yn
                },
              "booking_code": this.apartment_bookings.booking_code,
              "other_booking_details": this.apartment_bookings.other_booking_details,
              "arrived_start_date": null,
              "checkin_datetime": utils.addTimeZoneForTimestamp(checkin_datetime),
              "checkout_datetime": utils.addTimeZoneForTimestamp(checkout_datetime),
              "checkin_yn": this.apartment_bookings.checkin_yn,
              "booking_status": booking_status,
              "booking_company": this.apartment_bookings.booking_company,
              "booking_person_name"	:this.apartment_bookings.booking_person_name,
              "booking_person_email" :this.apartment_bookings.booking_person_email,
              "booking_person_phone":this.apartment_bookings.booking_person_phone,
              "deposit": this.apartment_bookings.deposit !==0 ? utils.formatInteger(this.apartment_bookings.deposit) : this.apartment_bookings.deposit,
              "deposit_deadline": deposit_deadline,
              "payment_in_advance": this.apartment_bookings.payment_in_advance !== 0 ? utils.formatInteger(this.apartment_bookings.payment_in_advance) : this.apartment_bookings.payment_in_advance,

              // [loitt] - #1171 GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN
              "company_name": this.apartment_bookings.company_name,
              "company_address": this.apartment_bookings.company_address,
              "company_tax_code": this.apartment_bookings.company_tax_code,
              "company_email": this.apartment_bookings.company_email,

              // [loitt] - #838
              "discount":  discount,
              "sale_off": sale_off,
              "ew_included": this.apartment_bookings.ew_included,

              // #1153: cho phep edit tra truoc, dat coc tra truoc
              "deposit_request": this.apartment_bookings.deposit_request !==0 ? utils.formatInteger(this.apartment_bookings.deposit_request.toString()) : this.apartment_bookings.deposit_request,
              "payment_inadvance_request": this.apartment_bookings.payment_inadvance_request !==0 ? utils.formatInteger(this.apartment_bookings.payment_inadvance_request.toString()) : this.apartment_bookings.payment_inadvance_request,

              "apartment_lease_back_clients_ids": apartment_lease_back_clients_ids,
              "apartment_mapping_with_booking_ids": [
                {
                  "apartment": this.apartment_id,
                  "pkg_template": this.apartment_bookings.pkg,
                  "booking_room_rate": utils.formatInteger(this.apartment_bookings.booking_room_rate.toString()),
                  "booking_room_rate_daily": utils.formatInteger(this.apartment_bookings.package_price_in_day.toString()),
                  "has_breakfast": this.apartment_bookings.has_breakfast,
                  "booking_room_rate_vat": this.apartment_bookings.vat,
                  "start_e": this.apartment_bookings.start_e,
                  "start_w": this.apartment_bookings.start_w,
                  "payment_duration_factor": this.apartment_bookings.payment_duration_factor,      
                  "other_details": this.apartment_bookings.pkg_other_detail,
                  "other_fee": utils.formatInteger(this.apartment_bookings.pkg_other_fee.toString()),
                  "other_vat": utils.formatInteger(this.apartment_bookings.pkg_other_vat.toString())
                }
              ]
            }
            this.data_booking = data_booking
            // Validate check-out date time
            let checkout_datetime_origin = utils.formatSqlDate(this.apartment_bookings.checkout_datetime_origin, "DD/MM/YYYY", "YYYY-MM-DD")
            let checkout_datetime_format = utils.formatDateTime(checkout_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'YYYY-MM-DD')
            let current_date = utils.formatDateTime(new Date(), 'YYYY-MM-DDTHH:mm:ss.sssZ', 'YYYY-MM-DD')
            if (utils.isNull(this.apartment_bookings.checkout_datetime)) {
              this.ON_SHOW_TOAST({
                message: this.$t('apartmentbookings.checkout_invalid'),
                styleType: "danger"
              });
              return;
            } else if (checkout_datetime_format != checkout_datetime_origin && checkout_datetime_format < current_date) {
              this.ON_SHOW_TOAST({
                message: this.$t('apartmentbookings.apartment_leaseback_clients.checkout_less_current_date'),
                styleType: "danger"
              });
              return;
            } else if ((booking_status === BookingStatusEnum.CONFIRMED) || ((booking_status === BookingStatusEnum.ONBOARD) && (this.booking_id === 0) || this.isCopyBooking)) {
              let is_valid_checkin = false
              if (booking_status == BookingStatusEnum.ONBOARD) {
                let current_date = new Date().setHours(new Date().getHours() + 12)
                let compareCurrentWithCheckInDate = utils.compareTwoDate(current_date, checkin_datetime, 'DD-MM-YYYY')
                let compareCurrentWithCheckOutDate = utils.compareTwoDate(current_date, checkout_datetime, 'DD-MM-YYYY')
                if ((compareCurrentWithCheckInDate == 0 || compareCurrentWithCheckInDate == 1) && (compareCurrentWithCheckOutDate == 0 || compareCurrentWithCheckOutDate == -1)) {
                  is_valid_checkin = true
                }
              }
              if (booking_status == BookingStatusEnum.ONBOARD && !is_valid_checkin) {
                this.ON_SHOW_TOAST({
                  message: this.$t('apartment.reservations.invalid_checkin_time'),
                  styleType: "danger"
                });
                this.waitingLoading(false)
                return false
              } else {
                if ((is_valid_checkin && booking_status == BookingStatusEnum.ONBOARD) || booking_status != BookingStatusEnum.ONBOARD) {
                  if (booking_status == BookingStatusEnum.ONBOARD) {
                    $("#modal-confirm-apartment-booking").modal("show")
                  } else {
                    this.ADD_APARTMENT_BOOKINGS(data_booking).then(
                      function (res) {
                        this.waitingLoading(false)
                        this.ON_SHOW_TOAST({
                          message: this.$t('customer.booking_successfully'),
                          styleType: "success"
                        });
                        this.callBackToList()
                      }.bind(this)
                    ).catch(
                      function (error) {
                        this.waitingLoading(false)
                        this.ON_SHOW_TOAST({
                          message: error.response.data.non_field_errors[0],
                          styleType: "danger"
                        })
                      }.bind(this)
                    );
                  }
                }
              }
            } else if (booking_status === BookingStatusEnum.CANCELLED) {
              $("#modal-cancel-apartment-booking").modal("show");
            } else {
              let is_valid_checkin = false
              if (booking_status == BookingStatusEnum.ONBOARD) {
                let current_date = new Date().setHours(new Date().getHours() + 12)
                let compareCurrentWithCheckInDate = utils.compareTwoDate(current_date, checkin_datetime, 'DD-MM-YYYY')
                let compareCurrentWithCheckOutDate = utils.compareTwoDate(current_date, checkout_datetime, 'DD-MM-YYYY')
                if ((compareCurrentWithCheckInDate == 0 || compareCurrentWithCheckInDate == 1) && (compareCurrentWithCheckOutDate == 0 || compareCurrentWithCheckOutDate == -1)) {
                  is_valid_checkin = true
                }
              }
              if (booking_status == BookingStatusEnum.ONBOARD && !is_valid_checkin) {
                this.ON_SHOW_TOAST({
                  message: this.$t('apartment.reservations.invalid_checkin_time'),
                  styleType: "danger"
                });
                this.waitingLoading(false)
                return false
              } else {
                if (booking_status == BookingStatusEnum.ONBOARD) {
                  $("#modal-confirm-apartment-booking").modal("show")
                } else {
                  const data = {
                    id: this.booking_id,
                    data: data_booking
                  }
                  this.UPDATE_APARTMENT_BOOKINGS(data).then(
                    function(res){
                      this.waitingLoading(false)
                      this.ON_SHOW_TOAST({
                        message: this.$t('customer.booking_successfully'),
                        styleType: "success"
                      });
                      this.callBackToList()
                    }.bind(this)
                  ).catch(
                    function (error) {
                      this.waitingLoading(false)
                      let error_message = error.response.data
                      if('other_booking_details' in error_message){
                        this.ON_SHOW_TOAST({
                          message: this.$t('apartmentbookings.apartment_leaseback_clients.error.other_booking_details'),
                          styleType: "danger"
                        })
                      } else if('apartment_mapping_with_booking_ids' in error_message){
                        this.ON_SHOW_TOAST({
                          message: this.$t('apartmentbookings.apartment_leaseback_clients.error.apartment_mapping_with_booking_ids_other_details'),
                          styleType: "danger"
                        })
                      } {
                        this.ON_SHOW_TOAST({
                          message: error.response.data.non_field_errors[0],
                          styleType: "danger"
                        })
                      }
                    }.bind(this)
                  );
                }
              }
            }
            
          } else if (result != 'OK'){
              this.waitingLoading(false)
              this.ON_SHOW_TOAST({
                message: result,
                styleType: "danger"
              })
          } else if (this.apartment_bookings.pkg == null) {
              this.ON_SHOW_TOAST({
                message: 'Bạn chưa chọn gói dịch vụ',
                styleType: "danger"
              });
          } else if (this.apartment_bookings.pkg == -1) {
              this.ON_SHOW_TOAST({
                message: 'Chưa có gói dịch vụ hợp lệ, vui lòng quay lại sau.',
                styleType: "danger"
              });
          } else {
              this.waitingLoading(false)
              this.ON_SHOW_TOAST({
                message: "Vui lòng liên hệ quản trị để biết thêm thông tin",
                styleType: "danger"
              })
          }
        },
        isCheck: function () {
            this.customerdata.is_company = this.customerdata.is_company == 0 ? 1 : 0;
            this.ischeck = this.customerdata.is_company == 1 ? true : false;
        },
        onSave: function(cont = true) {
            //this.disablecustomerform = cont
            this.$refs.formsubmitbutton.click();
        },
        validatePassword: function(password) {
            this.password_length = password.length;
            if(this.password_length <= 0){
                this.field_required.password= 'common.error_msg[0].required'
                return
            }

            if (this.password_length > 7) {
                this.valid_password_length = true;
            } else {
                this.valid_password_length = false;
            }

            if (this.password_length > 0) {
                this.password_typed = true;
            } else {
                this.password_typed = false;
            }

            this.contain_lowercase = /[a-z]/.test(password);
            this.contain_uppercase = /[A-Z]/.test(password);
            this.contain_number = /\d/.test(password);

            if (
                this.contain_lowercase == true &&
                this.contain_uppercase == true &&
                this.contain_number == true &&
                this.valid_password_length == true) {
                this.valid_password = true;
            } else {
                this.valid_password = false;
            }
        },
        validateEmail: function(email){
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!pattern.test(email)){
                email = ""
                return false
            } else {
                return true
        }
    },
      waitingLoading: function(bol) {
        this.isLoading = bol;
      },
      onChangeSelect: function(pkg) {
        this.apartment_bookings.pkg = pkg.id
      },
      setAvailableCustomers: function(data) {
        if (data !== undefined) {
          this.itemCustomer.data_list = data;
        }
      },
      getFullNameByLanguage(data){
        if (data != null) {
          return utils.getFullName(data.first_name, data.last_name, i18n.locale)
        } else {
          return utils.getFullName(this.main_person.resident.first_name, this.main_person.resident.last_name, i18n.locale)
        }
      },
      showModalAddCompany: function() {
        this.$refs.modalApartmentLeaseBackCompany.showModalAddCompany(null);
      },
      getLeaseBackCompany: function() {
        this.GET_LEASEBACK_COMPANY_LIST().then(
              function(res) {
                  this.leaseback_company_list = []
                  let leaseback_company_list = [];
                  let data = res.data;
                  leaseback_company_list.push({value: null, text: '---'})
                  data.forEach(c => {
                      let leaseback_company = {
                          value: c.id,
                          text: c.name
                      }
                      leaseback_company_list.push(leaseback_company);
                  })
                  this.leaseback_company_list = leaseback_company_list
              }.bind(this)
          )
      },
      reloadLeaseBackCompany: function() {
        this.getLeaseBackCompany();
      },
      onCancelBookingRoomRate: function(){
      },
      /**
        Author: [loitt] -#838
        Event: on Save Booking Room Rate from modal
        # Input :
            modal_booking_room_rate: Package Price / Month
            discount: promotion
        # Output:
            initializeBookingRoomRate()
            hide modal-main-package-price
      */
      onSaveBookingRoomRate: function(){
        $('#modal-main-package-price').modal('hide')
        this.initializeBookingRoomRate(this.apartment_bookings.modal_booking_room_rate, utils.formatInteger(this.apartment_bookings.discount.toString()), this.apartment_bookings.sale_off)
      },
      onChangePayment: function(val) {
        this.initializeBookingRoomRate(utils.formatInteger(this.apartment_bookings.booking_room_rate.toString()), utils.formatInteger(this.apartment_bookings.discount.toString()), utils.formatInteger(this.apartment_bookings.sale_off.toString()))
      },
      /**
        Author: [loitt] - #1253
        Event: on change company
        # Input :
            id company
        # Output:
            set field: company_email/company_tax_code/company_name/company_address
      */
      onChangeCompany: function(val){
        if(val == null){
          this.apartment_bookings.company_email = ""
          this.apartment_bookings.company_tax_code = ""
          this.apartment_bookings.company_name = ""
          this.apartment_bookings.company_address = ""
        } else {
          const result = this.GET_LEASEBACK_COMPANY_DATA.find( ({ id }) => id === val );
          this.apartment_bookings.company_email = result.email
          this.apartment_bookings.company_tax_code = result.tax_code
          this.apartment_bookings.company_name = result.name
          this.apartment_bookings.company_address = result.address
        }
      },
      /**
        Author: [loitt] -#956
        Event: check booking_payment_id == 0
        # Input :
            booking_payment_id
        # Output:
            true: disbale
            false: undisbale
      */
      disable_all: function() {
          return this.booking_payment_id > 0 ? true : false
      },
      async getBookingDetails(){
         await this.GET_BOOKING_DETAIL({id: this.booking_id}).then(
          function(res){
            let booking_data = res.data
             this.apartment_id = this.$route.query.is_copy_booking ? this.$route.query.apartment_id : booking_data.apartment_booking_detail.apartment_mapping_with_booking_ids[0].apartment
          }.bind(this)
        )

        const booking_data = {
          id: this.booking_id,
          params: {
            apartment: this.apartment_id
          }
        }
        this.GET_BOOKING_APARTMENT_DETAIL(booking_data).then(
          function (res) {
            let data = res
            this.booking_payment_id = data.booking_payment
          }.bind(this))
      }
    },
    async mounted() {
      this.is_view_only = this.$route.query.is_view_only
      this.GET_PROJECT_DETAIL({ id: utils.getProjectSession() }).then(
        function(res) {
          let projData = res.data
          this.hour_default_checkin = projData.df_chkin_hour
          this.minute_default_checkin = projData.df_chkin_minute
          this.hour_default_checkout = projData.df_chkout_hour
          this.minute_default_checkout = projData.df_chkout_minute
        }.bind(this)
      )

      this.isCopyBooking = !utils.isNull(this.$route.query.is_copy_booking) ? this.$route.query.is_copy_booking : null
      let booking_id = parseInt(this.$route.params.id);
      this.booking_id = booking_id
      if (this.booking_id !== 0 ){
        this.getBookingDetails()


      } else {
        let id = parseInt(this.$route.query.apartment_id) || 0;
        this.apartment_id = id
        this.apartment_bookings.checkin_datetime = this.$route.query.checkin_datetime;
        this.apartment_bookings.checkout_datetime = this.$route.query.checkout_datetime;
        this.getDepositDeadline(this.apartment_bookings.checkin_datetime, null)
      }
      this.GET_COUNTRY_LIST().then(
        function(res) {
          let countries = [
            {
              value: null,
              text: '---'
            }
          ];
          let data = res.data;
          data.forEach(c => {
              let country = {
                  value: c.id,
                  text: c.country_name
              }
              countries.push(country);
          })
          this.country_list = countries;
        }.bind(this)
      );
      this.getLeaseBackCompany();
      // Set date time check in, out default for client in apartment leaseback
      // this.apartment_leaseback_clients.checkin_datetime = utils.formatDateTimeWithHour(new Date(), 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm')
      // this.apartment_leaseback_clients.checkout_datetime = utils.formatDateTimeWithHour(new Date(), 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm')
    },
    components: {
      "lte-core-alert": LTECoreAlert,
      "date-picker": datePicker,
      loading: Loading,
      LeaseBackBookingPackageView,
      "leaseback-select-option-package": LeaseBackSelectOptionPackage,
      "lte-modal-partment-leaseback-company":LTEModalApartmentLeasebackCompany,
      "select-lease-back-clients-modal" : SelectLeaseBackClientsModal,
      "lte-modal-invoice-general-invoice-detail": LTEModalInvoiceGeneralInvoiceDetail,
      "lte-modal-update-apartment-info": LTEModalUpdateApartmentInfo,
    }
};
</script>

<style lang="scss" scoped>

.basic-sevice {
  margin-bottom: 10px;
}

.right-element-container {
    border:2px solid #cecece;
    margin-top:10px;
    margin-bottom:10px;
    margin-right:10px;
    background:white;
}


.inside-section-header {
    border-bottom: 1px solid #eee;
    margin-bottom: 9px;
    margin-top: 9px;
}

@media (min-width: 768px) {
    .modal-dialog {
        width: 800px;
    }
}

#modal-main-package-price .modal-dialog {
        width: 400px;
    }

.lnu_container {
  display: block;
  margin: 10px auto;
  margin-bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.lnu_container p {
  width: 30%;
  height: auto;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 98, .8);
  background: linear-gradient(to right, #06a65a 50%, #eee 50%);
  background-size: 200% 100%;
  background-position: right;
  -webkit-transition: background .3s;
  transition: background .3s;
}
.got_lowercase,
.got_uppercase,
.got_number {
  background-position: left !important;
  color: rgba(255, 255, 255, .9) !important;
}

.form-group.required .control-label:after {
    color: #d00;
    position: absolute;
    margin-left: 8px;
    margin-top: -3px;
    font-family: 'FontAwesome';
    font-weight: normal;
    font-size: 9px;
    content: "\f069";
}

.form-group.warning .control-label:after {
    color: #06a65a;  /* #ffa500 */
    position: absolute;
    margin-left: 8px;
    margin-top: -3px;
    font-family: 'FontAwesome';
    font-weight: normal;
    font-size: 9px;
    content: "\f069";
}

@mixin triangle ($size, $color, $direction) {
  height: 0;
  width: 0;

  $width: nth($size, 1);
  $height: nth($size, length($size));

  $foreground-color: nth($color, 1);
  $background-color: transparent !default;
  @if (length($color) == 2) {
    $background-color: nth($color, 2);
  }

  @if ($direction == up) or ($direction == down) or ($direction == right) or ($direction == left) {

    $width: $width / 2;

    @if $direction == up {
      border-left: $width solid $background-color;
      border-right: $width solid $background-color;
      border-bottom: $height solid $foreground-color;

    } @else if $direction == right {
      border-top: $width solid $background-color;
      border-bottom: $width solid $background-color;
      border-left: $height solid $foreground-color;

    } @else if $direction == down {
      border-left: $width solid $background-color;
      border-right: $width solid $background-color;
      border-top: $height solid $foreground-color;

    } @else if $direction == left {
      border-top: $width solid $background-color;
      border-bottom: $width solid $background-color;
      border-right: $height solid $foreground-color;
    }
  }

  @else if ($direction == up-right) or ($direction == up-left) {
    border-top: $height solid $foreground-color;

    @if $direction == up-right {
      border-left:  $width solid $background-color;

    } @else if $direction == up-left {
      border-right: $width solid $background-color;
    }
  }

  @else if ($direction == down-right) or ($direction == down-left) {
    border-bottom: $height solid $foreground-color;

    @if $direction == down-right {
      border-left:  $width solid $background-color;

    } @else if $direction == down-left {
      border-right: $width solid $background-color;
    }
  }

  @else if ($direction == inset-up) {
    border-width: $height $width;
    border-style: solid;
    border-color: $background-color $background-color $foreground-color;
  }

  @else if ($direction == inset-down) {
    border-width: $height $width;
    border-style: solid;
    border-color: $foreground-color $background-color $background-color;
  }

  @else if ($direction == inset-right) {
    border-width: $width $height;
    border-style: solid;
    border-color: $background-color $background-color $background-color $foreground-color;
  }

  @else if ($direction == inset-left) {
    border-width: $width $height;
    border-style: solid;
    border-color: $background-color $foreground-color $background-color $background-color;
  }
}
[class^="ribbon-"] {
  position: relative;
  //margin-bottom: 80px;
  &:before, &:after {
    content: "";
    position: absolute;
  }
}


// Ribbon-1
.ribbon-1 {
  width: 60px;
  height: 100px;
  background: #ee583a;
  top: -6px;
  left: 25px;
  &:before {
    @include triangle(6px, darken(#ee583a, 15%), down-left);
    right: -6px;
  }
  &:after {
    @include triangle(60px 30px, transparent #ee583a, up);
    bottom: -30px;
  }
}


// Ribbon-2
.ribbon-2 {
  width: 150px;
  height: 30px;
  //background: #21749a;
  background-color:#cecece;
  left: -8px;
  &:before {
    //@include triangle(8px, darken(#21749a, 15%), down-right);
    @include triangle(8px, darken(#cecece, 15%), down-right);
    top: -8px;
  }
  &:after {
    //@include triangle(50px 15px, #21749a, right);
    @include triangle(30px 15px, #cecece, right);
    right: -16px;
    top:-1px;
  }
}

.ribbon-21 {
  width: 150px;
  height: 30px;
  //background: #21749a;
  background-color:#cecece;
  left: -8px;
  &:before {
    //@include triangle(8px, darken(#21749a, 15%), down-right);
    @include triangle(8px, darken(#488BF8, 15%), down-right);
    top: -8px;
  }
  &:after {
    //@include triangle(50px 15px, #21749a, right);
    @include triangle(30px 15px, #488BF8, right);
    right: -15px;
    top:0px;
  }
}

.ribbon-22 {
  width: 150px;
  height: 30px;
  //background: #21749a;
  background-color:#f29911;
  left: -8px;
  &:before {
    //@include triangle(8px, darken(#21749a, 15%), down-right);
    @include triangle(8px, darken(#f29911, 15%), down-right);
    top: -8px;
  }
  &:after {
    //@include triangle(50px 15px, #21749a, right);
    @include triangle(30px 15px, #f29911, right);
    right: -15px;
    top:0px;
  }
}

// Ribbon-3
.ribbon-3 {
  width: 400px + 20px;
  height: 50px;
  margin-left: -10px;
  margin-right: -10px;
  background: #efb23b;
  &:before {
    @include triangle(10px, darken(#efb23b,15%), up-right);
    bottom: -10px;
  }
  &:after {
    @include triangle(10px, darken(#efb23b,15%), up-left);
    right: 0;
    bottom: -10px;
  }
}
.ribbon-4 {
  @extend .ribbon-3;
  &:before {
    @include triangle(20px, transparent darken(#37b7c7, 5%), inset-right);
    top: 20px;
    left: -30px;
  }
  &:after {
    @include triangle(20px, transparent darken(#37b7c7, 5%), inset-left);
    top: 20px;
    right: -30px;
  }
}
.ribbon-content {
  height: inherit;
  margin-bottom: 0; // reset the value in [class^="ribbon-"]

  background: #37b7c7;
  z-index: 100;
  &:before {
    @include triangle(10px, darken(#37b7c7, 15%), up-right);
    bottom: -10px;
  }
  &:after {
    @include triangle(10px, darken(#37b7c7, 15%), up-left);
    right: 0;
    bottom: -10px;
  }
}
@mixin flag($size:40px, $color:#CCC, $dir:left, $wrap-color: darken($color,5%)){
  /* general styles for all elements */
  position: relative;
  background: $color;
  &:before, &:after{
    border-style: solid;
    height: 0;
    width: 0;
    display: block;
    content:"";
    position: absolute;
  }
  /* styles specific to all horizontal */
  @if ($dir == "left" or $dir == "right" or $dir == "left-right"){
    height: $size;
    &:before, &:after{
      border-color: $color transparent;
      top: 0;
    }
  }

  /* for left and left-right */
  @if ($dir == "left-right" or $dir == "left"){
    &:before{
      left: -$size/2;
      border-width: $size/2 0 $size/2 $size/2;
    }
  }
  @if ($dir == "left-right" or $dir == "right"){
    &:after{
      right: -$size/2;
      border-width: $size/2 $size/2 $size/2 0;
    }
  }

  /* for all vertical*/
  @if ($dir == "up" or $dir == "down" or $dir == "up-down"){
    width: $size;
    &:before, &:after{
      border-color: transparent $color;
      left: 0;
    }
  }
    /* for and up-down and up*/
  @if ($dir == "up-down" or $dir == "up"){
    &:before{
      top: -$size/2;
      border-width: $size/2 $size/2 0 $size/2;
    }
  }

  /* for and up-down and down*/
  @if ($dir == "up-down" or $dir == "down"){
    &:after{
      bottom: -$size/2;
      border-width: 0 $size/2 $size/2 $size/2;
    }
  }
  i{
      display: block;
      position: absolute;
      height: 0;
      width: 0;
      right: 0;
      top: -$size/4;
      border-style: solid;
      content:"";
      border-color: $wrap-color;
      border-width: $size/4 $size/4 $size/2 0;
  }
}
div[class$="flag"]{
  //margin: 80px auto;
}
.right-flag{
  @include flag(2em, #cecece, right);
}

.dataTable thead .sorting:after,
.dataTable thead .sorting:before,
.dataTable thead .sorting_asc:after,
.dataTable thead .sorting_asc:before,
.dataTable thead .sorting_asc_disabled:after,
.dataTable thead .sorting_asc_disabled:before,
.dataTable thead .sorting_desc:after,
.dataTable thead .sorting_desc:before,
.dataTable thead .sorting_desc_disabled:after,
.dataTable thead .sorting_desc_disabled:before {
bottom: .5em;
}
#dtHorizontal th, td {
  white-space: nowrap;  
  padding: 10px 15px 10px 15px;
}
#apartmentInformation td {
  white-space: normal;
  padding: 0;
}
table {
  display: block;
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackApartmentBooking.vue